export const zh = {
    "k_cb1523d3": "组件管理",
    "k_620e0233": "模板管理",
    "k_cca20212": "公共账号",
    "k_666ddcb": "应用组",
    "k_faccfaca": "组件商店",
    "k_e98a694f": "权限中心",
    "k_c74d09ac": "使用文档",
    "k_a28e042b": "数据管理",
    "k_8b5d9d15": "智能开发",
    "k_fc190338": "模块名不能为空",
    "k_50a6aaab": "模块名由字母、数字、下划线、中划线组成，且只能以字母开头和 .js / .ts 结束",
    "k_8c566698": "该模块名已存在",
    "k_1893db7a": "输入以 .js 或者 .ts 结尾的模块名称, 按回车确认",
    "k_393dc7ee": "公告中心",
    "k_a26549c9": "全部",
    "k_4fd6d239": "展开查看详情",
    "k_9dadcb05": "无公告",
    "k_3d1a6848": "公告",
    "k_5870bbb8": "知道了",
    "k_475e8e0f": "操作",
    "k_3c26b6cc": "删除",
    "k_2a65347b": "query (url参数)",
    "k_9fd5fc78": "body (post包体)",
    "k_8a4fa7e2": "请输入JSON格式的对象",
    "k_f6a1ed55": "如果想进行动态绑定，请使用 {{}} 符号, eg: {{ state.foobar }}",
    "k_2a8e5f76": "已经合并过目标分支最新的提交",
    "k_2952c591": "合并",
    "k_b5b578ae": "合并此分支到master分支",
    "k_dcee32b2": "安全评审",
    "k_d0f054ae": "当前分支落后 master {arg_0} 个版本，点击可拉取",
    "k_b3e8a5e6": "当前分支落后 master，点击可拉取",
    "k_5c34f680": "检查并将master最新的修改合并到此分支",
    "k_1c675f24": "拉取",
    "k_d84bdaaa": "冲突已解决",
    "k_167b57af": "AI 项目合并成功",
    "k_c855e813": "没有需要合并的内容",
    "k_b55c2cae": "代码合并失败",
    "k_529ef0ee": "提交描述不允许为空",
    "k_30e49bab": "未选择任何变更",
    "k_e3c8a6b5": "[{arg_0}] 数据合并失败, 请检查是否还有冲突未解决",
    "k_89318787": "提交变更",
    "k_cb3bc158": "版本发布",
    "k_2f12b3e5": "提交信息（必填）",
    "k_9e48cac4": "取消",
    "k_a83a6196": "提交",
    "k_757f8e09": "代码合并",
    "k_2a958058": "代码合并计算中, 请耐心等待",
    "k_b5e4d814": "待解决",
    "k_c0ed04": "已合并",
    "k_f10de695": "AI 编辑器尚未就绪",
    "k_191b4dad": "等待 AI 编辑器保存超时",
    "k_3781cdf2": "保存成功但未返回项目信息",
    "k_6e133be7": "AI 编辑器保存失败",
    "k_dce404e9": "正在加载代码......",
    "k_5f4086f5": "目标分支：",
    "k_abcc76ad": "合并分支：",
    "k_5bf0cfa1": "还有 {arg_0} 个冲突未解决",
    "k_36b0947e": "{arg_0} 格式校验失败",
    "k_53299515": "，第 {arg_0} 行，第 {arg_1} 列",
    "k_743cd779": "解决以下冲突后",
    "k_47b9d88": "冲突已解决，点击 \"已解决\" 按钮标记为已解决",
    "k_722f2bb5": "个冲突待解决",
    "k_9346c618": "上一个",
    "k_c0a9baee": "下一个",
    "k_cb2316e1": "已解决",
    "k_ceabce69": "选择合入版本",
    "k_773d8833": "选择当前版本",
    "k_b67c3745": "分支合并：{arg_0} → {arg_1}",
    "k_cff22f3a": "分支合并",
    "k_d9bc4f74": "请先解决所有冲突",
    "k_21f67470": "[MergeModal] 获取分支名称失败:",
    "k_d8fd8b86": "[MergeModal] 初始化变更数据失败:",
    "k_4ce8da47": "离开确认",
    "k_58dc3fac": "确定离开",
    "k_ce3f3f": "再想想",
    "k_2c142eaa": "AI 项目保存失败，请重试：{arg_0}",
    "k_8120aba": "未知错误",
    "k_e4fdcd4f": "[{arg_0}] 数据合并失败，请检查是否还有冲突未解决",
    "k_a8a55532": "[MergeView] 解析 AI 项目 before YAML 失败:",
    "k_bf01a9f5": "[MergeView] 解析 AI 项目 after YAML 失败:",
    "k_c3a416ea": "冲突未解决",
    "k_ef55ab6f": "代码已合并",
    "k_5d2b94": "YAML 格式无效",
    "k_58c7fc17": "JSON 格式无效",
    "k_216c1998": "使用{arg_0}版本",
    "k_a0e0f1d7": "使用当前版本",
    "k_79f7a837": "使用远程版本",
    "k_2926ff7": "保留两个版本",
    "k_9e5b90e": "提交成功",
    "k_b98a8a6": "提交失败:{arg_0}",
    "k_bca7b6c3": "请放置组件",
    "k_69092539": "腾讯公司 版权所有",
    "k_a4ea733e": "无极",
    "k_97542633": "页脚",
    "k_330cb30d": "组合",
    "k_305f3524": "预设页脚",
    "k_12849352": "页头",
    "k_24f6ce51": "导航",
    "k_b84d2038": "导航栏",
    "k_aa07e056": "菜单",
    "k_46aa3f41": "菜单栏",
    "k_b5a6f668": "系统内置",
    "k_b729fdd7": "当前流程",
    "k_52092425": "流程单ID",
    "k_44b560ad": "流程单标题",
    "k_9381362e": "状态",
    "k_33d28a3d": "发起时参数",
    "k_ea69e7ef": "全局变量",
    "k_f6148a12": "各节点数据",
    "k_fa8ec205": "流程状态说明",
    "k_66ca76fd": "发起人",
    "k_c279a045": "当前审批人",
    "k_36dc214a": "关注人",
    "k_eb51ec65": "流程类型",
    "k_f185b9aa": "流程发起时间",
    "k_740ff4b6": "环境",
    "k_1562a2e0": "流程单网址",
    "k_88d94282": "流程页面的区块",
    "k_b4fb734e": "区块标题",
    "k_e80e44f6": "时间",
    "k_7dde8972": "对应步骤节点ID",
    "k_c7a47147": "对应步骤节点类型",
    "k_72c30a28": "刷新页面数据",
    "k_33da2838": "等待下一区域",
    "k_f1245ab2": "[FlowPagePlugin] 页面片刷新失败",
    "k_fb554f50": "审批用页面能力",
    "k_32db480f": "用于渲染高级流程",
    "k_ee653527": "流程ID",
    "k_591fc75e": "流程节点ID",
    "k_7d8fd189": "开始",
    "k_8c92bffb": "当前流程节点",
    "k_d059bee4": "节点ID",
    "k_e80a8160": "这是默认的区块",
    "k_b25b8862": "打散以编辑",
    "k_99ed33f5": "注意：打散后，如果你在流程设计时添加了新的参数，这里不会自动同步！",
    "k_f88f8663": "默认页面片内容",
    "k_3cb1dbe3": "这个整体是默认的表单块，根据流程配置自动生成的",
    "k_e700dbeb": "如果你需要编辑内部，请点击“打散”按钮",
    "k_3e60674e": "打散",
    "k_e3817a4e": "如果只是想补充一些说明和图例，不建议打散 —— 把要展示的东西，放区块上面/下面/右边就行",
    "k_eb6cec41": "区块加载失败：",
    "k_fd7071b4": "刷新",
    "k_e2e1a99a": "在这里放置表单",
    "k_2e3e2c4f": "流程节点的页面片",
    "k_7f5b428d": "要进行页面配置，请在左侧直接操作",
    "k_820f76c6": "要配置数据源事件，请通过顶部【行为】面板操作",
    "k_8c549f74": "无法加载这个节点",
    "k_294189cd": "节点标题",
    "k_c3bfd630": "输出的内容",
    "k_7fdb8aa6": "是否已执行",
    "k_81770304": "是否运行时",
    "k_55bd96f5": "执行时间",
    "k_d45b3ee7": "这不是发起流程的页面",
    "k_3dfa72a3": "是否只读",
    "k_4ed57936": "可用于区分当前是【发起流程页】还是【流程信息查看页】",
    "k_d3d1a668": "发起流程",
    "k_665c9970": "使用 form 里的数据发起流程",
    "k_3dc6a067": "是否立即跳到流程详情页",
    "k_1579945c": "包括 { id, url } 分别是流程单ID、流程单页面地址。",
    "k_c2ce280e": "流程单页面地址",
    "k_71036c9b": "请按要求填写完整信息",
    "k_68a001fc": "审批意见",
    "k_4a42e4ce": "审批结果",
    "k_7ce77cd": "附加数据",
    "k_7aff1b77": "是否可以审批",
    "k_a0951a2e": "审批状态",
    "k_351d41f8": "未进入",
    "k_12d95d6e": "已同意",
    "k_54e06e46": "已拒绝",
    "k_55ec099b": "审批节点的首次进入时间",
    "k_5cadee77": "审批人",
    "k_e5d094ae": "同意",
    "k_d14daea": "拒绝",
    "k_44fb841f": "审批记录",
    "k_6cc38515": "审批时间",
    "k_fa00bbb2": "审批操作",
    "k_1d73f81f": "审批操作名（中文）",
    "k_ed961e3a": "审批附加数据",
    "k_a0e67e5f": "是否可以修改审批人",
    "k_994d8238": "正在修改审批人",
    "k_668bae6f": "是否可以撤回",
    "k_1fe4d4bf": "处理审批",
    "k_99672127": "使用当前填的审批意见、附加数据，然后同意或拒绝审批",
    "k_1cea4d5e": "操作类型（approve或reject）",
    "k_ff07d297": "审批表单信息",
    "k_5553721e": "是否刷新页面",
    "k_5aca5e7e": "修改审批人",
    "k_5c8a182c": "撤回审批单",
    "k_e6283fe0": "撤回原因",
    "k_c1b3cb0f": "保存修改",
    "k_f1458645": "请输入审批意见",
    "k_e3e07049": "审批发起时间",
    "k_e6fb224f": "请输入撤回原因",
    "k_6700ebc5": "{{ data.item.operation === \"request-cancel\" ? \"撤回原因\" : \"审批意见\" }}",
    "k_25f752a6": "{{data.item.comment || '无'}}",
    "k_866f69f2": "新审批人",
    "k_e9e3297b": "data.item.operationName || \"未知操作\"",
    "k_3885bb71": "通过",
    "k_102c726b": "审批失败：{arg_0}",
    "k_8e77bf6d": "修改审批人失败，请重试：{arg_0}",
    "k_929f8376": "撤回审批失败，请重试：{arg_0}",
    "k_a3cad6aa": "审批表单",
    "k_df78b0e0": "审批信息",
    "k_9d008cf4": "重置区块",
    "k_62521600": "字段数据授权",
    "k_6ff22294": "页面仅可访问此处授权的数据。请不要把敏感数据泄漏给访客",
    "k_8980aaaa": "复制 job.{arg_0}",
    "k_9a6d8611": "已复制: {arg_0}",
    "k_35aad5f8": "正在更新授权",
    "k_2c2f879c": "请通过【顶部工具栏】授权流程数据",
    "k_a5921763": "授权...",
    "k_cd628148": "流程： {arg_0} ",
    "k_77fe6ac4": "数据授权",
    "k_565a8431": "Mock：流程发起页",
    "k_785015e3": "打开流程详情页. {arg_0}",
    "k_4f8f39b2": "数据： {arg_0} ",
    "k_fadfd038": "流程发起页",
    "k_3dfef779": "流程编辑器已打开。记得两边都要保存",
    "k_a408a449": "去设计流程",
    "k_392ef241": "[刷新流程]按钮",
    "k_27bc4c62": "无极AI插件",
    "k_fb9fec5a": "该插件已废弃且不生效，仅支持禁用",
    "k_6df11f6c": "点击右上角按钮或按 Esc 键退出全屏模式",
    "k_7a7edf9f": "退出全屏",
    "k_c0e292d8": "全屏",
    "k_e9becb72": "应用配置修改未保存, 是否需要保存再跳转?",
    "k_3c521f89": "不保存",
    "k_3f4f470": "保存",
    "k_13b92170": "数据源管理",
    "k_2ec141c4": "搜索名称或ID",
    "k_282d84cd": "新建数据源",
    "k_a5a9d846": "项目数据库：",
    "k_d9b21596": "添加数据库",
    "k_453d502a": "名称",
    "k_9ff5ee55": "类型",
    "k_d676fdb1": "负责人",
    "k_8468a7c8": "修改时间",
    "k_556c0507": "查看数据",
    "k_fb50bc50": "编辑",
    "k_141fa2c5": "复制",
    "k_36a4e2bc": "请输入复制后的数据源ID并确认",
    "k_8435ee84": "日志",
    "k_e8aa1def": "确定要删除该数据源吗？",
    "k_426162fa": "没有符合条件的数据源",
    "k_1f8dc194": "请添加数据源",
    "k_bbc6de30": "加载数据源失败 {arg_0}",
    "k_f2356931": "加载数据源标签失败 {arg_0}",
    "k_ddd1107d": "加载项目数据库失败:",
    "k_d30e55a9": "加载项目数据库失败 {arg_0}",
    "k_3d8cd427": "添加数据库成功",
    "k_de073575": "复制成功, 新ID: {arg_0}",
    "k_f57efe67": "复制失败，已存在相同ID: {arg_0}",
    "k_aaebdce5": "复制失败，错误信息: {arg_0}'",
    "k_d65486be": "删除成功",
    "k_3bd4ac22": "删除失败 {arg_0}",
    "k_e2fabe4a": "DB-数据表",
    "k_5273f268": "增删改查",
    "k_1dafe382": "DB-执行SQL",
    "k_9a731279": "执行SQL语句",
    "k_5d150a39": "DB-MySQL多表读写",
    "k_7b4a81bf": "多表事务操作、关联查询",
    "k_33dc5b17": "DB-跨服访问",
    "k_52fbde01": "访问其他无极部署版本的DB",
    "k_ab1cb42d": "单个HTTP接口",
    "k_90b2a7d": "请求后台服务",
    "k_e1b2f73b": "多个HTTP接口组合",
    "k_28680282": "请求一套增删改查的后台服务",
    "k_1652e773": "在线NodeJs接口",
    "k_aeb2ce06": "在线编写云函数",
    "k_8b838246": "多表",
    "k_28dcc801": "跨服访问",
    "k_28aa4883": "项目依赖信息",
    "k_51860ac6": "修改版本号后保存来实现版本的更新 - 此处的修改是项目级别的",
    "k_4ebe6540": "请注意：",
    "k_8c3fe156": "无法在此处添加/删除依赖，需在源码中添加或删除引用才能生效",
    "k_d509bfbb": "还原",
    "k_a0efafaf": "更新依赖",
    "k_6b92e9b6": "主页面",
    "k_c333ec96": "数据",
    "k_46c3e034": "布局",
    "k_6e635fa8": "[UICore组件]:无效的自定义物料面板配置",
    "k_c06c2c7e": "UICore容器",
    "k_f6384246": "插入",
    "k_c3942516": "页面内容",
    "k_2c16c9d2": "模式",
    "k_bccbb9f8": "设计模式",
    "k_6736ec1d": "渲染模式",
    "k_4a333030": "数据模式",
    "k_adad0e66": "绑定的数据将挂载到内部的state.data",
    "k_bcfb16ff": "传入数据",
    "k_5dc28f4c": "透传数据源",
    "k_7cf0b757": "默认容器类型",
    "k_53b1fe9f": "布局的默认根容器",
    "k_9dd92ad4": "自定义物料面板",
    "k_a39d2cc3": "[帮助文档]({arg_0})",
    "k_3173df24": "组件面板",
    "k_e22b369d": "编辑器UI修剪",
    "k_79536a36": "数据源面板",
    "k_1b40488d": "样式面板",
    "k_56d71f77": "行为面板",
    "k_ab925eae": "工具栏",
    "k_da1a5fd9": "正在编译 {arg_0}",
    "k_1481c444": "编译 {arg_0} 失败: {arg_1}",
    "k_4939c751": "编译 {arg_0} 失败:",
    "k_c85989c4": "方向性图标",
    "k_be0f1047": "编辑类图标",
    "k_8cc21a4e": "数据类图标",
    "k_c4e04048": "网站通用图标",
    "k_5362661c": "提示建议性图标",
    "k_3b4ee996": "创建/更新知识库失败:",
    "k_738a9cf3": "获取知识库失败:",
    "k_e9ea39c9": "搜索知识库失败:",
    "k_cdc43d07": "获取项目知识库权限失败: {arg_0}",
    "k_39f9ebaf": "添加/更新项目知识库权限失败:",
    "k_55130185": "删除项目知识库权限失败:",
    "k_1adebcdc": "CLI工具未启动调试命令，请检测后重试",
    "k_d9fad8fc": "本地启动的是https服务，但是客户端请求的是http的接口。",
    "k_53525e4": "切换到https",
    "k_9ed7300e": "本地 HTTPS 使用自签证书，浏览器未信任。请先打开 https://localhost:9998 ，在证书警告页选择「继续前往」后再刷新本页。",
    "k_4c40c17": "或改用 HTTP 调试：组件目录执行 http=true npm start，并切换到 http",
    "k_618ccf3b": "切换到http",
    "k_5c5bafb7": "本地启动的是http服务，但是客户端请求的是https的接口。",
    "k_8e240863": "本地开发者工具启动https调试模式",
    "k_9ac8d514": "开发工具如何开启https本地服务",
    "k_13969097": "https页面禁止加载http资源，因此加载本地开发资源失败。",
    "k_d91ee4a": "页面使用http重新加载",
    "k_d5bd0640": "模块",
    "k_c7ec97ab": "确定",
    "k_7876b718": "很遗憾，加载本地开发{arg_0}失败",
    "k_364bed80": "请求本地开发接口失败，通常为浏览器设置限制导致，可以按照以下指示逐一排查：",
    "k_c5938325": "场景",
    "k_72401e86": "- 控制台报错：",
    "k_bb4c927a": "解决方法",
    "k_edd438c2": "请求本地开发接口失败，请使用Chrome浏览器进行开发",
    "k_288dca7b": "JSON校验不通过",
    "k_572ee3e": "请手动解决以下冲突：",
    "k_b3641d9": "个冲突待处理",
    "k_32db19dd": "标记冲突已解决",
    "k_3c906aba": "不合并,直接保存本地",
    "k_ac638a8e": "请解决冲突",
    "k_94e9d997": "取消合并",
    "k_7d824d0f": "提交合并",
    "k_d1f81e1e": "解决冲突",
    "k_f6adc2b2": "[mock]获取页面数据失败",
    "k_da8a7768": "[mock]数据保存成功",
    "k_4dca5e38": "mock数据编辑",
    "k_377c499d": "Mock标题",
    "k_6bc5d09c": "弹窗",
    "k_b38ad245": "系统组件",
    "k_c4d09e95": "打开",
    "k_a964d573": "注意：不要在这个时候调用数据源的方法",
    "k_4a7e579c": "关闭",
    "k_b74f8a6e": "弹窗容器",
    "k_b9820cc3": "重置页脚",
    "k_54506580": "找不到[{arg_0}]对应的弹窗",
    "k_b69805f3": "[标题] 请放置组件",
    "k_36abb697": "[内容] 请放置组件",
    "k_9a705dbd": "[页脚] 请放置组件",
    "k_1d95ad3f": "属性",
    "k_292eff31": "展示类型",
    "k_a722db1": "外观",
    "k_1b9d7833": "抽屉",
    "k_6e56fd31": "移动端适配",
    "k_dcbfb24": "抽屉的方向",
    "k_a0bfb874": "上",
    "k_d373c2f5": "右",
    "k_608053e3": "下",
    "k_b74b2d05": "左",
    "k_c9532c0f": "宽度",
    "k_ee68c4c2": "高度",
    "k_1d29bee4": "显示标题",
    "k_8e8f4d76": "显示页脚",
    "k_bbe3cd8b": "自定义标题",
    "k_8bdba086": "标题",
    "k_153c239e": "显示右上角的关闭按钮",
    "k_b78610c4": "功能",
    "k_8b0a5d82": "展示蒙层",
    "k_1825e093": "支持点击蒙层关闭",
    "k_76157496": "支持键盘 ESC 关闭",
    "k_20a11748": "关闭时保留实例",
    "k_2c03fd1c": "关闭参数",
    "k_552ea40a": "通过右上角的关闭按钮/点击蒙层/键盘ESC关闭时的默认返回参数",
    "k_f4da8ef": "当前为debug模式",
    "k_5542def7": "请选择",
    "k_86cb51ae": "路径未定义，无法进行预览",
    "k_ec16344c": "debug模式拉取页面列表失败，请确认是否开启本地开发服务",
    "k_e6214383": "该页面未配置路径，无法跳转",
    "k_339c3ea3": "当前项目没有页面，导航栏中的在线组件无法预览使用数据源的场景",
    "k_471da1da": "语言",
    "k_a6caebd4": "获取语言配置失败:",
    "k_a6cb1411": "预览模式不支持操作",
    "k_bbd94903": "该导航组[{arg_0}]没有配置页面菜单",
    "k_e73e0041": "模拟",
    "k_373f9513": "请在自定义域名产物端预览",
    "k_ae04823f": "未登录",
    "k_efae8637": "个人信息",
    "k_e4921fd6": "密钥",
    "k_1c7700b9": "获取密钥",
    "k_c2a5ce68": "恢复超管或运维身份",
    "k_3f348d7": "体验非超管或运维身份",
    "k_d3a0f925": "个人 AI 用量",
    "k_35db4ccf": "企业 AI 用量",
    "k_2eea10d2": "部署 AI 用量",
    "k_2abd22c6": "获取密钥失败：{arg_0}",
    "k_8ea39b3e": "复制秘钥",
    "k_374559b9": "获取秘钥",
    "k_e7624279": "复制成功",
    "k_de69e180": "复制失败！{arg_0}",
    "k_3e0857e6": "待办",
    "k_f2c81f4b": "搜索环境",
    "k_8c98ac18": "无匹配环境",
    "k_b6db99ab": "修改页面",
    "k_9b1b0c6c": "用小程序访问",
    "k_626f1799": "应用权限",
    "k_b86ba482": "权限和密钥",
    "k_c103f530": "新用户注册审批",
    "k_e28b2f78": "应用组管理",
    "k_2c8fe39a": "恢复管理员角色",
    "k_b7722afb": "体验非管理员角色",
    "k_60038845": "退出登录",
    "k_e59b454a": "退出模拟登录",
    "k_85d5bda2": "无极 1.0",
    "k_d835c796": "过期时间",
    "k_acb9c6b9": "使用场景",
    "k_242a4446": "创建时间",
    "k_2ecf2c41": "获取 MCP Key 列表失败: {arg_0}",
    "k_b88b2726": "请填写使用场景",
    "k_14af6211": "申请成功，正在跳转到审批流程详情页...",
    "k_2090abdf": "申请失败: {arg_0}",
    "k_8014ef31": "已复制到剪贴板",
    "k_9aed9623": "复制失败",
    "k_294ecaac": "我的权限",
    "k_356013f2": "继承自组织",
    "k_eadabe83": "永久",
    "k_1cbd7c30": "申请续期",
    "k_697cd19b": "角色",
    "k_2d74feb9": "点击角色名称查看详细权限",
    "k_50c61f18": "MCPKey",
    "k_c0e51e12": "申请 MCPKey",
    "k_94158804": "申请需要由项目管理员审批",
    "k_975011de": "启用",
    "k_4c0c49a6": "停用",
    "k_b29acb15": "申请新 MCP Key",
    "k_b5d96930": "请描述 MCP Key 的使用场景",
    "k_2c3885e7": "快速切换",
    "k_ac4e9d62": "环境切换",
    "k_6f0e8888": "环境ID",
    "k_256e835": "环境名称",
    "k_8a71f19f": "添加",
    "k_5a34c9cd": "生产环境",
    "k_eb361e9": "测试环境",
    "k_7c89b8c0": "开发环境",
    "k_801ae80d": "预发布环境",
    "k_6e9edec8": "环境选项不能为空",
    "k_c5cc7969": "环境配置有重复的选项 '{arg_0}'",
    "k_c692acb4": "搜索",
    "k_43f9cdd3": "点击展开更多",
    "k_5aa48296": "审批页面",
    "k_97f497d6": "你有{arg_0}条待办审批",
    "k_29d5a22d": "待办审批",
    "k_3e19f854": "我发起的审批",
    "k_da780fe2": "触发刷新方法",
    "k_22042ed4": "预置事件A",
    "k_fe78cc40": "通过 `触发页面片事件` 行为触发该事件执行",
    "k_a08b60b9": "触发事件行为的自定义传参",
    "k_2ba647c1": "预置事件B",
    "k_411bd345": "预置事件C",
    "k_fb29d0db": "预置事件D",
    "k_cb2c0538": "预置事件E",
    "k_ccf32c61": "内嵌页面(片)",
    "k_70ecae12": "哪个流程",
    "k_d8227216": "哪个节点",
    "k_9701c2ec": "页面",
    "k_2f628aaf": "页面片",
    "k_f6f2e934": "在当前页面通过",
    "k_deb1b3a5": "获取内嵌实例",
    "k_35d819a0": "在内嵌实例通过",
    "k_bc3d436d": "获取当前页面",
    "k_486f408d": "数据加载中，请稍后...",
    "k_c446b47a": "请选择页面(片)",
    "k_10ab8a98": "页面( {arg_0} )不存在或无权访问，请联系应用管理员 ",
    "k_32559d66": "页面(片)",
    "k_8d6cfa32": "当前页面内的页面片",
    "k_886863ff": "流程节点",
    "k_c164976": "流程和节点",
    "k_58eb68b8": "参数 (页面/页面片内通过 props.xxx 取参)",
    "k_1263d911": "加载模式",
    "k_49efeb54": "默认模式显示加载文案和进度条",
    "k_1a462199": "默认",
    "k_166d4347": "占位",
    "k_b90123e9": "静默",
    "k_d0722a3": "提示",
    "k_3764454c": "回车保存",
    "k_63a265fd": "新建标签",
    "k_e4aac70c": "标签名称不能为空",
    "k_3c51fdef": "不允许创建重复的标签名",
    "k_13bc5f1d": "获取页面标签列表失败:{arg_0}",
    "k_b10c4baf": "创建标签失败：{arg_0}",
    "k_d1ab8b07": "删除标签失败:{arg_0}",
    "k_7976dccb": "更新标签失败:{arg_0}",
    "k_a85e651": "修改 {arg_0}  id 需要手动更新 LessCode 和关联的组件配置 ",
    "k_4fde6e2b": "{arg_0}名称",
    "k_9e497eb": "{arg_0}描述",
    "k_c8242e52": "请输入描述",
    "k_d3707e74": "{arg_0}{arg_1} 不能为空",
    "k_8c9e2fe1": "{arg_0}{arg_1} 已经存在",
    "k_c3aaf766": "ID由字母、数字、下划线、中划线组成，且只能以字母开头",
    "k_fd6ab5b2": "插槽",
    "k_66783720": "事件",
    "k_bc85a2de": "参数",
    "k_db6f2e39": "组件联动方法",
    "k_fa2ae7a2": "未知的页面{arg_0}",
    "k_f18bbba2": "组件内参数 - {arg_0}",
    "k_ecb3f718": "请将组件拖到此处",
    "k_465aa45a": "组件内数据源",
    "k_d79bdc25": "预置事件A触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_a956fbce": "预置事件B触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_23c9346": "预置事件C触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_b1df00e9": "预置事件D触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_b0c5c32a": "预置事件E触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_dcc4a296": "内嵌页面片",
    "k_a28ee87e": "升级组件",
    "k_4ad68318": "请选择页面片",
    "k_e8e5df89": "页面片参数 (页面片通过 props.xxx 取参)",
    "k_88590c3": "页面权限",
    "k_51bf2f26": "在{arg_0}中{arg_1}数据",
    "k_fb75e62e": "自定义权限",
    "k_16ea7c75": "内置权限",
    "k_705f6629": "新建权限",
    "k_a7ec5ea4": "新建角色",
    "k_56fe2f6c": "扩展插件列表",
    "k_26b26449": "扩展插件列表浮层",
    "k_8c4cf301": "配置",
    "k_4f39dc1f": "禁用",
    "k_f7e87aaa": "全应用",
    "k_d828db0e": "当前页",
    "k_945221f2": "请问是要全应用启用还是只在当前页启用？",
    "k_3d6dae32": "暂时还没有扩展插件~",
    "k_5b26cc4d": "当前登录会话已过期，请重新登录",
    "k_d5f24c87": "已退出当前登录会话，请重新登录",
    "k_82f993d9": "因平台安全策略更新，请重新登录",
    "k_44e3bc79": "检测到登录态已过期，请重新登录",
    "k_26a3fe00": "登录态已过期",
    "k_737f422d": "重新登录",
    "k_d641f8b5": "菜单获取路由失败",
    "k_f51e95ca": "Sidebar.setCurrentGroup: 找不到 {arg_0} 菜单组",
    "k_4578bc06": "Powered by 无极",
    "k_cbd2ed02": "关闭其他",
    "k_f80c5985": "本地缓存",
    "k_80a48a8a": "第 {arg_0}  个页面 ",
    "k_fad97a17": "开发者工具",
    "k_c37894be": "数据源操作（旧版）",
    "k_d312931f": "真的要执行操作吗？",
    "k_e660b89": "表单型",
    "k_d252758f": "表单",
    "k_db9a6f98": "带标签的表单",
    "k_dfa0dd9": "带标签的",
    "k_6871664a": "可双向绑定",
    "k_80f3b0da": "请在数据源->URL参数中定义$query.{arg_0} 并开启双向绑定 即可修改query",
    "k_f7bae376": "URL参数",
    "k_d462acc0": "数据源依赖",
    "k_d0e41c20": "模拟路由动态参数",
    "k_919e39d6": "传给弹窗的参数",
    "k_a6769979": "传给页面片的参数",
    "k_11febe51": "方法",
    "k_f5cd078f": "全局实例 / 全局 LessCode 实例",
    "k_75a2df0a": "多语言翻译",
    "k_9597d9dc": "不匹配字段正则表达式：{arg_0}",
    "k_e9524cc": "[templateSources] 模板数据源 \"{arg_0}\" 遮蔽了页面上同名数据源，保存时会还原页面原件",
    "k_40ead0fd": "模板",
    "k_4f4b3b06": "页面模板",
    "k_f5f35e47": "数据源日志",
    "k_932ce511": "UI交互",
    "k_f5254608": "逻辑",
    "k_ccd9cc09": "数据源",
    "k_7b36b47a": "导入导出",
    "k_ff744567": "页面导航",
    "k_3960fc20": "草稿",
    "k_4c349cd3": "外部通知",
    "k_3e0d1f1f": "审批流",
    "k_cecdb728": "流程",
    "k_2862e786": "AI行为",
    "k_29468fa1": "三路合并",
    "k_217525ad": "可以对两个版本内容基于基准版本进行对比合并",
    "k_215f06fc": "基准内容",
    "k_bebf07a7": "远程内容",
    "k_35121f81": "当前内容",
    "k_6fbaf5d7": "提示合并结果",
    "k_2452e775": "合并的结果",
    "k_f18f16b8": "合并失败{arg_0}",
    "k_a02b9455": "保存草稿",
    "k_27d07796": "是否提示用户",
    "k_aad473bc": "指定命名空间",
    "k_58030b7e": "在需要区分业务下使用，不指定时草稿默认在当前页面或者弹窗使用",
    "k_9c9e78ba": "是否保存当前的草稿？",
    "k_8a892778": "恢复草稿",
    "k_e51e6ef4": "用户取消恢复草稿后是否保留草稿",
    "k_bd606fe9": "是否恢复上次编辑的内容？",
    "k_8ce1e294": "恢复",
    "k_e1ac22e6": "删除草稿",
    "k_5d6990a5": "如果保存草稿指定了命名空间，需要输入对应的命名空间",
    "k_13a8199d": "Excel导出",
    "k_8def6363": "支持xlsx、xlsm、csv(单工作表)格式文件的导出",
    "k_eeaec374": "导出的数据",
    "k_8de077c8": "1、使用页面变量 eg: data.yourSource.listData \n2、使用上一个流程的执行结果 eg: flowState.res.listData",
    "k_2effff72": "配置模式",
    "k_19de9bca": "字段配置",
    "k_c7c908fe": "动态字段配置",
    "k_4b3c20e6": "文件名",
    "k_68e3ed73": "表名",
    "k_f896aba3": "支持的格式",
    "k_93910646": "csv格式不支持多sheet导出",
    "k_e15c599f": "导出成功",
    "k_bcc6464": "[excel导出] 目标数据不是数组",
    "k_b75e711d": "[excel导出] 无效的字段配置",
    "k_2e2bfd56": "[excel导出] {arg_0}",
    "k_ffb2cb19": "Excel导入",
    "k_fc362b96": "后续步骤可通过 `flowState.__file__` 获取导入的文件对象",
    "k_558e2802": "原始数据",
    "k_3c1ac1e4": "以 Date 输出日期类型",
    "k_a07ade": "字符集",
    "k_9d343e75": "当前sheet数据",
    "k_ab2fd52": "当前行数据",
    "k_675524a": "excel导入的数据",
    "k_2b9ae399": "上传至COS",
    "k_66897280": "COS桶",
    "k_75eba9b0": "多环境配置(若无需区分环境则不需要配置此项)",
    "k_8fa91e29": "文件",
    "k_5ed30431": "上传路径",
    "k_ab62831f": "上传头部",
    "k_2ab4858f": "头部 key 需要是标准写法，比如 Content-Type",
    "k_39e5732a": "上传文件路径",
    "k_8a717ba0": "上传至COS失败，无效的文件或COS桶配置",
    "k_a58e76c4": "提取文件数据",
    "k_4c6e5af6": "仅支持提取文本类文件数据\n如JSON/CSV/SQL/纯文本文件",
    "k_bcf42508": "是否支持多选",
    "k_6e046da0": "是否支持选择文件夹",
    "k_6808e00c": "不支持该文件类型",
    "k_a4ab74ec": "文件提取错误{arg_0}",
    "k_86a61cad": "文件数据",
    "k_2683fbfa": "文件对象",
    "k_2b78c99b": "复制文本",
    "k_fd314ad8": "复制内容",
    "k_f9f2ba58": "请设置内容",
    "k_fa3e9dc4": "是否提示复制成功",
    "k_ea9668c3": "调用 LessCode 方法",
    "k_6c4a4a7": "支持 async 的被调方法。会等待完成后，才执行后续步骤。",
    "k_136b2e90": "方法名",
    "k_668dcab": "若方法返回false 就终止流程",
    "k_132f3e5c": "如果需要使用变量、表达式，请使用双花括号",
    "k_ac5168de": "被调用函数的返回结果",
    "k_2742a48a": "未找到 {arg_0} 方法",
    "k_6df3c2fa": "将在 Console 输出当前步骤的一些调试信息，需配合浏览器 DevTools 查看",
    "k_461604b1": "在线组件发送事件",
    "k_16369f69": "将事件从这个在线组件中抛出",
    "k_b641daa8": "事件Key",
    "k_6c5950ca": "事件名称",
    "k_d4a9d62c": "事件参数",
    "k_179d8e4a": "此处的返回值会作为事件参数传递给使用这个在线组件的页面",
    "k_b78a92ae": "参数描述",
    "k_7fdf389": "滚动失败, 找不到 {arg_0} 的组件",
    "k_95ef785e": "滚动页面",
    "k_3e45c1a2": "滚动位置",
    "k_e6d681e1": "顶部",
    "k_e20c63be": "底部",
    "k_43368a95": "指定位置",
    "k_b00dff6": "指定组件",
    "k_b0e1bf8a": "纵轴位置 (单位: px)",
    "k_305b32b3": "组件",
    "k_3c4a03fc": "组件偏移类型",
    "k_f69a92ff": "组件偏移值 (单位: px)",
    "k_2ec227fd": "滚动行为",
    "k_4adfec41": "瞬间",
    "k_bff2dc8a": "平滑",
    "k_c8131ca6": "跳转页面",
    "k_74fc2ea3": "页面ID",
    "k_15980a00": "页面 query 参数",
    "k_38a133a4": "页面 params 参数(替换页面路径中的动态参数)",
    "k_abb410c9": "新窗口打开",
    "k_50e3b7e2": "跳转方式",
    "k_9866df8a": "push (history 添加新记录)",
    "k_713c4b44": "replace (history 不添加新记录)",
    "k_73f40a65": "跳转失败, 无效的页面路径",
    "k_463d4473": "是否打开：{arg_0}",
    "k_c8cd5c3d": "跳转链接",
    "k_6ecc6f31": "无效跳转链接",
    "k_83dee5ca": "返回上一页",
    "k_679d8bd4": "是否返回上一页",
    "k_f74babfc": "刷新页面",
    "k_60faae12": "刷新页面片",
    "k_a04eeb3a": "邮件发送失败",
    "k_564045b4": "企业微信通知失败",
    "k_cb0c139c": "企业微信客服号通知失败",
    "k_7fd7aa57": "邮件通知",
    "k_aeeddca": "发送人",
    "k_f9ea78a5": "收件人",
    "k_902196d0": "抄送",
    "k_9e1be7d3": "密送",
    "k_646011a0": "邮件主题",
    "k_2a5af184": "邮件内容",
    "k_950eed59": "收件人,主题或内容为空,请检查",
    "k_74a14ee8": "企微机器人通知",
    "k_df6b2766": "消息格式详情请[点击查看](https://developer.work.weixin.qq.com/document/path/95274)",
    "k_6b0143be": "机器人",
    "k_452499c5": "消息",
    "k_d212955": "成功通知",
    "k_ce9f22e9": "机器人通知配置错误",
    "k_f61dfa4a": "机器人消息应为有效的 JSON",
    "k_858a290e": "机器人通知成功",
    "k_78a10542": "机器人通知失败",
    "k_781e2f73": "企业微信通知",
    "k_f34627de": "通知设置",
    "k_41e79eab": "通知应用（消息发送方）",
    "k_fdbedf8": "消息接收人类型",
    "k_8bb652da": "消息接收人",
    "k_ff841d1f": "消息类型",
    "k_7454f20": "内容",
    "k_d663218e": "链接",
    "k_9c4c9dc": "按钮文本",
    "k_64babb9a": "详情",
    "k_ca02b77d": "企业微信通知-消息接收人不能为空",
    "k_20ded012": "企业微信通知-文本内容不能为空",
    "k_acf52c6b": "企业微信通知-Markdown内容不能为空",
    "k_edaaf97e": "企业微信通知-文本卡片消息配置有误",
    "k_1ec66a3b": "企业微信通知成功",
    "k_c3e7de2c": "唤起企业微信",
    "k_d700b76b": "唤起配置",
    "k_9b026908": "企业微信名",
    "k_8e926d67": "企业微信名(动态)",
    "k_d7d9aaf": "客服号(uin)",
    "k_f72d031f": "企业微信名不能为空",
    "k_93e4c99f": "企业微信客服号不能为空",
    "k_ccba562e": "刷新数据",
    "k_26b9f0c6": "(旧版)从数据源重新拉数据",
    "k_e7fe36bf": "数据源ID",
    "k_f914ae3f": "(旧版)提交修改到数据源",
    "k_fda52c45": "行为类型",
    "k_985c95cf": "自动(创建/更新)",
    "k_2c8cc473": "[单条模式] 创建",
    "k_c685108e": "[单条模式] 更新",
    "k_2e5eae47": "[单条模式] 删除",
    "k_9ef16ebb": "[列表模式] 更新列表",
    "k_c9929d84": "操作完成后，重新载入表单数据",
    "k_da5a3292": "操作失败：（错误码{arg_0}）{arg_1}",
    "k_cad5b4b8": "操作失败",
    "k_4d88f459": "数据源操作结果（创建模式下，为型如 { \"id\": xxxx } 的对象）",
    "k_b656efee": "(上古版)审批驳回",
    "k_68eaf671": "(上古版)审批同意",
    "k_f1f77303": "(上古版)发起流程",
    "k_4b3481f5": "新建对象ID",
    "k_cf416f03": "审批同意(废弃)",
    "k_53ade266": "流程实例ID",
    "k_80a4f7e5": "当前状态",
    "k_826df261": "流程实例 ID 不能为空",
    "k_b0c83858": "审批失败{arg_0}",
    "k_f5518bdb": "审批驳回(废弃)",
    "k_b9bcd6a6": "发送HTTP请求",
    "k_7a38e68f": "* 以上所有输入框都支持填写插值表达式",
    "k_9ca32af": "请求方法",
    "k_ac34c87b": "请求是否带上Cookie",
    "k_98d15e06": "超时时间(毫秒)",
    "k_28a6c177": "请求失败的提示文案",
    "k_b9b9f0a8": "请求的响应结果",
    "k_bd6a4749": "请求失败{arg_0}",
    "k_d62e0465": "数据源操作（弃用）",
    "k_4167191d": "触发页面片事件",
    "k_6c4d3ff3": "外部可通过 `$event.XXX` 拿到这里给出的事件参数 XXX",
    "k_e86f3a8f": "触发事件名",
    "k_230b1765": "选择事件",
    "k_39c61fb2": "触发页面片事件[pagelet:emitEvent]: 必须选择事件",
    "k_bd07b32b": "调用数据源接口",
    "k_ec59b262": "调用数据源接口并返回接口调用结果，支持批量调用 (注意该步骤不会更新页面数据)",
    "k_409f979f": "[调用数据源接口]{arg_0}接口找不到",
    "k_1fff1378": "[数据源请求] parse db body fail",
    "k_d51661c7": "返回包体",
    "k_c9e1a874": "错误对象(如果有)",
    "k_5e33e7e7": "批量调用数据源接口",
    "k_8d8070e0": "批量调用数据源接口并返回接口调用结果，区别于'调用数据源接口'中的前端批量，这里的批量是单接口后端批量。目前只有DB数据源支持此操作",
    "k_237ad5c": "数据源操作",
    "k_23853ce8": "哪一个数据源,值格式：data.{sourceId}.$methods,其中 sourceId 要通过 Information 指令获取",
    "k_f508bc5": "数据源的方法ID，通过 Information 指令获取。",
    "k_c199ae21": "数据源 {arg_0} 不存在",
    "k_9eb9d1d2": "数据源 {arg_0} 没有名为 {arg_1} 的方法",
    "k_551045b7": "数据源重新初始化",
    "k_4ec7a197": "该行为会批量并发调用所有数据源的初始化(init)方法",
    "k_de91ca00": "关闭弹窗",
    "k_5a006242": "返回参数 (在打开弹窗行为接收)",
    "k_a7445e17": "弹出消息窗口",
    "k_20a7ae71": "文案",
    "k_c24d22cd": "请设置文案",
    "k_5aec5cc9": "图标",
    "k_aa889a09": "无图标",
    "k_a80ac70b": "宽度(可选)",
    "k_53bbde8f": "示例： 300px",
    "k_e0784cdf": "弹出确认框",
    "k_3a49de55": "文案 (支持HTML)",
    "k_97105ad3": "选择了“否”就终止流程",
    "k_6b16c907": "确定按钮文字",
    "k_c60fa5d0": "取消按钮文字",
    "k_dc53da43": "垂直居中展示",
    "k_9ed6bbd6": "用户确认结果",
    "k_1b7a7f0": "弹出提示",
    "k_ebe72edb": "提示类型",
    "k_c3cfc45f": "提示持续时间",
    "k_6426c44": "是否为同步提示",
    "k_7b4c99db": "提示内容",
    "k_b6200d91": "弹出通知框",
    "k_ca6b5c1f": "弹出位置",
    "k_7485784b": "左上方",
    "k_d55d16f8": "右上方",
    "k_cf7162dc": "左下方",
    "k_3d093e98": "右下方",
    "k_3fa7cb03": "通知标题",
    "k_35433cae": "通知内容",
    "k_373379db": "请设置通知内容",
    "k_2a72389b": "弹出文字输入框",
    "k_7803dae9": "提示消息",
    "k_20f56626": "请输入一些东西：",
    "k_ba45e89f": "默认值",
    "k_986b06a6": "密码模式",
    "k_8c33a6ff": "输入框模式",
    "k_fd24931": "单行文本",
    "k_2c43a2e9": "多行文本",
    "k_cbaddf0a": "密码",
    "k_d9335985": "允许空字符串",
    "k_6eb9032f": "选择了“取消”就终止流程（否则会使用默认值）",
    "k_a6cef13b": "用户输入的文本",
    "k_cef231d3": "打开弹窗",
    "k_6b381d6": "弹窗关闭后, 才执行后续步骤",
    "k_88ec7b8b": "选择弹窗",
    "k_bc4829c5": "全局弹窗设置",
    "k_92f695df": "弹窗参数 (弹窗内通过 props.xxx 取参)",
    "k_e1d734d2": "弹窗关闭行为的返回值",
    "k_d82e437e": "创建的数据 id 无效",
    "k_23443dd8": "没有找到对应的电子流配置",
    "k_752e0ee": "是否同时使用 [{arg_0}] 的数据作为Excel导出的数据",
    "k_236e3692": "使用",
    "k_f7e3218e": "不使用",
    "k_f1d01f7a": "点此查看使用方法",
    "k_3e2bff02": "导出模式",
    "k_86c0ee0c": "单工作表",
    "k_fbc35e98": "多工作表",
    "k_71b5879c": "导出字段配置",
    "k_9d05f1a7": "配置模式(固定列)",
    "k_f1b2274f": "代码模式(动态列)",
    "k_afca030b": "使用模板参数",
    "k_ab3e2fe": "计算导出的表配置",
    "k_efbd6214": "列名",
    "k_af95f247": "取数字段",
    "k_5801ccce": "支持嵌套取值 eg: a.b ；a[0].b",
    "k_ddf83ed": "列宽",
    "k_93411675": "输入展示的字符数目",
    "k_7cb8d8e6": "拖动可以调整顺序",
    "k_685725c0": "无法通过 [{arg_0}] 找到对应的DataStub",
    "k_3d9077d9": "是否覆盖已有字段结构",
    "k_2659b38c": "找不到有效的字段",
    "k_4db590d6": "选择导出的数据结构",
    "k_945cd5f0": "展开",
    "k_f98b656f": "获取环境失败",
    "k_72209108": "获取cos桶失败",
    "k_c6d6321c": "获取cos列表失败",
    "k_39cbb313": "获取列表失败",
    "k_3842dc50": "没有邮箱配置，点击去",
    "k_697b3a2c": "新建",
    "k_63f6085a": "关闭时不销毁",
    "k_1f6adbcc": "实例id",
    "k_97c79ad8": "该id用于打开多个不销毁的全局弹窗实例时区分实例",
    "k_2d3f59e5": "body请用json格式书写（若用了插值表达式，插值表达式也需要用双引号包住）",
    "k_61aa6432": "添加Header",
    "k_6442f789": "添加Query",
    "k_5cd23c3e": "全局 LessCode",
    "k_54c8eb8e": "当前页面片 LessCode",
    "k_7af0f1ca": "当前页面弹窗",
    "k_56521be0": "全局弹窗",
    "k_925cf2f1": "双向绑定数据",
    "k_dd1ad259": "已绑定到 {arg_0} ",
    "k_81cb80fb": "修改",
    "k_7fe59327": "解绑",
    "k_6634d0ee": "添加双向绑定",
    "k_1c3a2997": "添加参数",
    "k_77bc86a6": "无机器人，点击去",
    "k_6e3cca73": "请选择...",
    "k_f01dd83d": "此数据源不支持“操作”",
    "k_3f9c7e13": "接口",
    "k_c8dc68f3": "此数据源未配置接口",
    "k_be5485b": "请求参数",
    "k_ef06983": "生成默认参数",
    "k_80c1f0c8": "生成批量请求参数",
    "k_91588be6": "查看文档",
    "k_5ef529ac": "javascript传参",
    "k_dcf80ab9": "表单传参",
    "k_2aff46c6": "该数据源支持自定义数据源方法，推荐使用自定义数据源方法进行请求，以获得更好的体验",
    "k_31490b4d": "获取collection信息失败",
    "k_2cd6f5fd": "不传参",
    "k_26ccb713": "使用默认参数",
    "k_9c9d4d10": "编辑该方法",
    "k_58c9473d": "数据源方法",
    "k_4fc7cedc": "如果想自定义参数，可切换到[表单传参]或[javascript传参]进行配置。",
    "k_8bec7ece": "* 查询数据的操作，参数比较固定，推荐使用[表单传参]",
    "k_7204597e": "*\n        create/update等接口的调用、或者参数比较复杂，推荐[javascript传参]",
    "k_b88bade9": "哪个数据源",
    "k_32a7471d": "哪个{arg_0}",
    "k_19a0e4b5": "消息发送方",
    "k_305e5cb7": "平台提供",
    "k_b257ebd6": "暂无平台提供的企业微信应用",
    "k_5dd444e8": "应用配置",
    "k_9808dfd3": "可自定义企业微信应用",
    "k_179e3623": "动态设置",
    "k_45852bd6": "固定设置",
    "k_5023cf7a": "查看详情",
    "k_6cbb034e": "文本",
    "k_d9fb7e1e": "文本卡片",
    "k_11c00bab": "文本内容",
    "k_4f054dd5": "可以支持换行、以及超链接，如: 查看<a href='http://x.y.z';>详情</a>，长度限制 2048",
    "k_6fd72d07": "Markdown内容",
    "k_5e1d3473": "支持的markdown语法",
    "k_428000f6": "可以支持换行、以及mark语法的子集，如: [查看](http://x.y.z)，长度限制 2048",
    "k_eee3f94b": "卡片标题，长度限制 128",
    "k_68a8d96e": "卡片内容，长度限制 512",
    "k_905be975": "点击卡片跳转的链接，长度限制 2048",
    "k_f570ff32": "按钮文字",
    "k_cd0a617c": "长度限制 4",
    "k_8f3e651a": "机器人文档和内部客服文档",
    "k_3b5c4691": "企业微信个人(固定)",
    "k_a8fcb588": "企业微信个人(动态)",
    "k_963e4e05": "企业微信客服",
    "k_f3124961": "返回值",
    "k_56cdf72a": "输出结构",
    "k_818c3f63": "英文名",
    "k_ed9a0638": "此方法返回值由自定义方法返回👉",
    "k_d9c2c95f": "查看自定义代码",
    "k_7598fa6a": "方法没有返回值",
    "k_6a4d2a98": "[数据源 {arg_0} 初始化出错] {arg_1}",
    "k_1c4318b0": "[数据源 {arg_0} 初始化出错]",
    "k_151c8588": "发起请求",
    "k_66cbb9fe": "{arg_0} 请求",
    "k_d195a613": "完整的表单",
    "k_9d4a9653": "创建模式下",
    "k_4d81e17": "编辑模式下",
    "k_732987b6": "创建",
    "k_92dc87c4": "更新",
    "k_51790c4d": "确定要删除吗？",
    "k_6f1dedb": "重置表单",
    "k_4db936aa": "提交列表修改",
    "k_70210d79": "(自动)新建或者修改当前数据",
    "k_d1333a89": "新建数据",
    "k_746cf9c7": "修改当前数据",
    "k_2306be16": "删除当前数据",
    "k_1eb5601b": "数据源 {arg_0}载入数据失败：{arg_1}",
    "k_880fed03": "数据源{arg_0}载入数据失败：",
    "k_46049079": "提 交",
    "k_e1574ccc": "修改已提交",
    "k_8a731d2a": "已删除",
    "k_81385ec6": "[删除]按钮",
    "k_fe771102": "[提交修改]按钮",
    "k_33cdee69": "数据源 {arg_0} 配置了 pageCon.filter，同时还有 filterCon。已放弃前者",
    "k_21a38a3c": "当前不是编辑模式，请检查程序",
    "k_55c394fd": "要制作表单，请先添加一个数据源",
    "k_f29d33ce": "添加数据源",
    "k_a9ea92d4": "请选一个数据源，以生成表单？",
    "k_e6065cb0": "使用空白表单",
    "k_2b9375a4": "操作失败，无法为 {arg_0} 生成表单，请联系平台方反馈问题",
    "k_8ec7fb96": "请通过组件库面板 - 数据源，寻找需要的字段",
    "k_6fedc048": "管理数据源",
    "k_4eb4c0b1": "从数据源导入字段...",
    "k_832868a7": "当前你的表单里已经有些东西了，切换数据源会丢失原有内容。是否继续？",
    "k_28300e9f": "无法导入此数据源，请通过左侧“数据源”自行拖拽制作表单",
    "k_48981cad": "数据字段",
    "k_cc4dfd38": "根据数据表结构，推荐用这个组件",
    "k_5c3d1497": "只读字段，请绑定数据",
    "k_b0808e9b": "标题 The Title",
    "k_2608ee83": "副标题 如果不需要可以删除",
    "k_c63574bc": "这里是一些介绍文字。。请注意修改，或者绑定到数据项的已有字段上",
    "k_dfdb705b": "附加文案，不需要可以删除",
    "k_292a39c5": "一个按钮",
    "k_7c5b509a": "按钮1",
    "k_b732fdaf": "按钮2",
    "k_1f3e8d07": "详情卡片",
    "k_cf1fdba4": "图片卡片",
    "k_381f690b": "列表卡片",
    "k_68b75749": "列表视图",
    "k_c59ad37d": "树状视图",
    "k_89dfa6fb": "评审视图",
    "k_1e6c906f": "提交版本不同，但文件内容一致",
    "k_f1f96a69": "无文件变更",
    "k_ca71a54e": "缺少必要的版本信息",
    "k_2e68944b": "加载文件失败，请重试",
    "k_7b9a18b9": "展开文件夹",
    "k_d27548a7": "收起文件夹",
    "k_532f379d": "切换视图",
    "k_3699bfd2": "切换代码变更视图",
    "k_877783df": "加载中...",
    "k_b8e13dae": "无",
    "k_693a56b4": "点击复制完整 commit id",
    "k_aa982dcc": "复制 commit {arg_0}",
    "k_b1546e5a": "代码变更 ({arg_0})",
    "k_ee5ecc61": "拖动调节宽度",
    "k_e8b499ed": "收起文件目录",
    "k_f7803405": "展开文件目录",
    "k_63b38a6b": "请选择一个文件查看详情",
    "k_9da91dca": "重新解决冲突",
    "k_c68232f2": "切换为单栏模式",
    "k_3467c439": "切换为双栏模式",
    "k_ab4dad4a": "线上版本",
    "k_d93e74f0": "本地版本",
    "k_5714949e": "基础版本",
    "k_b7f6e22c": "请勿外传",
    "k_3e3d6057": "依赖上传失败: {arg_0}",
    "k_95a6aab0": "依赖更新中...",
    "k_a9ccf0cc": "依赖更新失败 - 请检查外部依赖的包名是否错误",
    "k_21a398de": "默认导航",
    "k_49bbfe3d": "默认菜单",
    "k_2e31d2c1": "初始化",
    "k_38319534": "此时数据源可能还没就绪， **不能调用数据源方法**",
    "k_5e5f6e2c": "渲染完成",
    "k_c4903939": "此时页面渲染完成",
    "k_fd2154bd": "当前页面 renderer 实例",
    "k_3a1d25e0": "数据源就绪",
    "k_4736f697": "此时可以调用数据源方法了。如果数据源有配置“打开页面时自动拉数据”，那么会等待拉取完成，才执行这里的逻辑",
    "k_adbe1ec9": "销毁",
    "k_7d79e4df": "已复制到剪贴板: {arg_0}",
    "k_92ea52af": "重新加载整个页面",
    "k_dc205c89": "编辑器已经连接",
    "k_904adff5": "已连接编辑器",
    "k_3f1465e5": "编辑器未连接",
    "k_2f000ff": "页面配置已更新",
    "k_eeb8e00d": "局部刷新{arg_0}",
    "k_8d7fe155": "刷新{arg_0}",
    "k_2f0d5b88": "有重复打开的编辑器",
    "k_945ddc11": "您打开了另一个同页面的编辑器",
    "k_173a924c": "当前编辑器的预览功能已被暂停使用",
    "k_8c217a8b": "激活当前编辑器",
    "k_988200bf": "关闭提示",
    "k_c41f48d3": "数据源更新",
    "k_c1489344": "强制重新加载",
    "k_4a3296e7": "项目信息修改",
    "k_a23c2a6": "逻辑或数据源变化",
    "k_d9a4808a": "默认红",
    "k_993229d6": "无极蓝",
    "k_ba84332e": "PCG蓝",
    "k_c26ac7b5": "腾讯蓝",
    "k_8ddd72b1": "天空蓝",
    "k_cdede42c": "页面加载失败，{arg_0}",
    "k_d5712fa0": "拉取全局变量配置失败，请确认本地CLI服务是否启动，或升级CLI工具：{arg_0}",
    "k_4f7290aa": "导航-菜单-内容",
    "k_f2466883": "导航-内容",
    "k_6d149e31": "菜单-内容",
    "k_6c269693": "跟随应用",
    "k_dce4646": "固定",
    "k_fbe7ae1e": "不固定",
    "k_bc84d7ca": "开启",
    "k_88400715": "页面JS资源加载失败",
    "k_83025a92": "未命名折叠面板",
    "k_b8ef81a0": "流程单ID: `{{ job.id }}` / 网址",
    "k_fe083896": "job.id // 新建流程单时不展示",
    "k_2765b22f": "当前审批人为：{{ job.currentApprovers || '...' }}",
    "k_d81b1c61": "复制信息 + 一键拉群",
    "k_b2d4c395": "复制信息",
    "k_6310181e": "您好，请留意审批单据《{{ job.title }}》\n\n{{ job.url }}",
    "k_cc304f42": "流程运行中",
    "k_77336e3c": "流程: {{ job.title }}",
    "k_16ce1b93": "发起时自动填表",
    "k_d772e0d1": "流程实例详情",
    "k_5f57e1ec": "获取插件列表失败:{arg_0}",
    "k_2f8fbf1f": "执行扩展插件{arg_0}失败:{arg_1}",
    "k_bd977f56": "获取扩展插件失败",
    "k_dafeb107": "暂未获取到可供调试的扩展插件:{arg_0}",
    "k_4e283f52": "跳转至编辑页",
    "k_348661c8": "下拉菜单",
    "k_74e84bf4": "业务",
    "k_560ca57e": "主菜单切换",
    "k_3b8a1d87": "生成中...",
    "k_4e6645fe": "服务器开小差，请重新生成二维码",
    "k_1af84802": "此功能暂未开放，请联系管理员开通权限",
    "k_6362e219": "智能解析API文档",
    "k_5e4b1170": "解析失败",
    "k_42030fd8": "解析完成，请确认你要使用的内容",
    "k_3112ecbd": "确定使用",
    "k_3e4d3d3b": "在下方粘贴API文档，即可自动填写接口配置",
    "k_4d069d64": "结果不准确？可以调整输入后再次解析。",
    "k_e05f90f6": "解析",
    "k_4244c878": "请将HTTP API的说明文档（包括地址、参数说明等）粘贴进来，无格式要求",
    "k_815ead9": "请贴入API文档",
    "k_d515a191": "你是 HTTP API 文档解析助手。从 API 说明或请求代码中提取接口配置。只输出一个 JSON 对象，不要 markdown 代码块，不要任何解释文字。",
    "k_c1ad9dc5": "AI 返回内容不是合法 JSON：\n\n{arg_0}",
    "k_4b4a1b59": "接口名",
    "k_c0450c07": "接口描述",
    "k_5711bfb0": "域名",
    "k_204a8af5": "路径",
    "k_fdf83a6f": "响应类型",
    "k_a89cabc6": "query参数",
    "k_8ac45484": "body参数",
    "k_acd0529e": "请求头",
    "k_64529138": "// 设置请求头",
    "k_7e78ae76": "路径参数",
    "k_2cba109": "// 插值替换URL里的参数{arg_0}",
    "k_86494cc3": "没有解析出东西。以下为原始响应：\n\n{arg_0}",
    "k_21da6064": "已解析完成，请确认结果",
    "k_3f2b2c69": "API文档解析错误",
    "k_2580b15": "已应用，注意检查调试参数",
    "k_b47396e6": "无极 AI 功能调用失败",
    "k_7f5a357e": "你没有该项目的编辑权限",
    "k_c7e09b38": "该页面已被菜单使用，请先在菜单中移除该页面后再重试。",
    "k_3758526a": "该页面当前被设为项目首页，请先修改首页设置后再重试。",
    "k_5e7dcd48": "该页面已被工作流使用，请先删除或解除相关工作流后再重试。",
    "k_40a6cb49": "页面内容已保存，但国际化扫描失败：{arg_0}。请检查后重试。",
    "k_6df3ec54": "页面内容已保存，但国际化信息保存失败，请稍后重试。",
    "k_10a28dc7": "项目设置已保存，但国际化扫描失败：{arg_0}。请检查后重试。",
    "k_30329d4c": "项目设置已保存，但国际化信息保存失败，请稍后重试。",
    "k_214a73db": "代码已保存，但多语言扫描失败：{arg_0}。请检查后重试。",
    "k_d607c47": "代码已保存，但多语言信息保存失败，请稍后重试。",
    "k_96a9633a": "当前存在路径为“/”的页面（{arg_0}），首页设置不会生效。请先删除该页面后再设置首页。",
    "k_bf2170b7": "父页请求合并保存失败:",
    "k_51b91241": "保存失败: {arg_0}",
    "k_2b870b4b": "保存失败",
    "k_56c1a46e": "检测到分支合并参数:",
    "k_ceb78fed": "合并 {arg_0} 到 {arg_1} 分支",
    "k_4492a142": "AI项目合并失败:",
    "k_8acd29ae": "分支合并失败: {arg_0}",
    "k_bf230c2f": "依赖加载",
    "k_ab08dc44": "依赖构建失败，请打开控制台查看详情",
    "k_b32f7432": "保存成功",
    "k_283da999": "以下页面保存失败，请根据原因处理后重试：",
    "k_6a45762e": "编译失败",
    "k_ae3a48e7": "文件编译失败，是否确定继续发布？",
    "k_ade4e59c": "上传已取消",
    "k_80ea9001": "附件上传失败：{arg_0}",
    "k_ecc03546": "正在加载AI项目...",
    "k_b19d4ff3": "加载失败",
    "k_dca31870": "未找到 AI 项目 ESM 入口（artifactCos.js）",
    "k_6be6212c": "加载AI项目失败: {arg_0}",
    "k_ca6cb596": "当前项目没有后台产物，无法重新构建",
    "k_5f19f440": "默认代理",
    "k_830425e9": "publish 服务请求超时 ({arg_0}ms): {arg_1}",
    "k_7f065035": "publish 服务网络错误: {arg_0}",
    "k_b82cea97": "publish 服务 HTTP {arg_0}: {arg_1}",
    "k_c33419b7": "正在准备AI页面开发环境",
    "k_2206a7e6": "{arg_0}AI编辑器",
    "k_93284bb7": "无极应用",
    "k_9c3d1f8c": "创建容器接口没有返回事件流",
    "k_2b0e5975": "容器创建成功，但接口未返回 service_url",
    "k_3c073f1f": "创建容器失败",
    "k_df849638": "创建容器接口已结束，但未返回完成事件",
    "k_613dc9a9": "正在复用容器...",
    "k_4b741401": "容器复用成功，但接口未返回 service_url",
    "k_eb25ef7": "已复用容器",
    "k_694e6bc4": "正在提交容器创建请求...",
    "k_fa06eb3d": "容器创建失败",
    "k_d129778e": "正在创建 AI 编辑器容器",
    "k_a815dd36": "重试",
    "k_188d3dd7": "正在唤醒 AI 编辑器容器",
    "k_cc73995d": "当前阶段：{arg_0}",
    "k_ff04ee3d": "[customRequire] 未实现 {arg_0}",
    "k_e94bb974": "检测到页面资源加载失败，请刷新页面重试",
    "k_91fcdff4": "当前分支",
    "k_a0c92d39": "目标分支",
    "k_72f7d125": "初始化 AI 项目失败",
    "k_f580681d": "你没有权限访问该项目",
    "k_50bff2d1": "仍然继续",
    "k_d080ede": "因为后台逻辑不同，可能产生脏数据。建议先「保存」项目，然后刷新预览",
    "k_a9840375": "服务端逻辑有变更",
    "k_af1a0fd6": "检测到代码变更，正在检查部署状态...",
    "k_365d2479": "后端服务部署中",
    "k_273a0b56": "正在创建新的后台服务...",
    "k_23f1a5fd": "后端服务部署失败",
    "k_58a12523": "部署失败，请检查代码或重新部署",
    "k_322e8507": "后台逻辑有变化",
    "k_fb8d3080": "您的编辑器内容落后了，建议「保存」后刷新预览",
    "k_99a7219d": "部署成功",
    "k_55e935eb": "后端服务已就绪",
    "k_4b8ce8a6": "您需要先保存，才能看到效果。",
    "k_d5f96348": "后端代码有变更，请先「保存」项目，然后刷新预览",
    "k_8f78fe2d": "后端服务部署中，请稍等",
    "k_5ddc9a0e": "后端服务未部署",
    "k_2d2025c4": "已登录，请重试",
    "k_c8b3e950": "File Worker 错误:",
    "k_d97d79e": "Worker 返回错误:",
    "k_a765637d": "收件人、主题或内容为空，请检查",
    "k_c1767c7": "机器人ID或消息内容不能为空",
    "k_a6543aad": "消息内容格式错误，请传入有效的JSON",
    "k_7fbdc837": "消息接收人不能为空",
    "k_a8f78fff": "消息内容不能为空",
    "k_ac7aa0b1": "文本卡片消息配置有误",
    "k_8d2306ed": "客服号消息仅支持文本和Markdown类型",
    "k_176d681e": "重复路径：{arg_0}",
    "k_987eef87": "页面ID {arg_0} 被多个路径占用：{arg_1}",
    "k_446752f6": "AI页面路径冲突，请修改页面路径后再保存。",
    "k_bfad681e": "主页",
    "k_102bb28f": "无法为被占用的页面路径生成备份路径：{arg_0}",
    "k_b2357a57": "AI页面路径冲突：路径 {arg_0} 生成的页面ID {arg_1} 已被页面 {arg_2}（路径：{arg_3}）占用，请修改路径后再保存。",
    "k_819549e0": "列表接口",
    "k_f5cff5c8": "原始数据结构",
    "k_22b32378": "查询总数",
    "k_f861ac6": "新建接口",
    "k_eb511250": "更新接口",
    "k_74916e98": "获取接口",
    "k_cbae8d48": "删除接口",
    "k_edbdc2f2": "当前数据结构",
    "k_299e1ad8": "没有权限访问",
    "k_94834e4b": "请尝试",
    "k_639d63e6": "登录",
    "k_9c9c4e1c": "后再访问",
    "k_dfa53415": "申请权限",
    "k_651d8e10": "返回",
    "k_3d9af866": "注意：权限数据环境隔离，当前环境",
    "k_ba45a844": "校验权限失败",
    "k_2bebc367": "你正在体验非管理员角色",
    "k_f2521368": "非正式环境",
    "k_7b67695d": "格式化失败，请检查是否有语法错误",
    "k_e3df4b6d": "直接编辑流程配置",
    "k_7e41426e": "系统默认",
    "k_2d1f9a83": "该页面片是为本流程的节点「{arg_0}」设计的，请确认表单字段与流程参数是否匹配",
    "k_6861e24": "两个节点的类型不同（{arg_0} → {arg_1}），页面片里「当前流程节点」的数据结构不兼容，很可能无法正常工作",
    "k_43403f2e": "该页面片是为流程「{arg_0}」的节点「{arg_1}」设计的，请确认表单字段与流程参数是否匹配",
    "k_9781afb8": "它的流程数据授权是按原流程配置的，字段名不一致时取值会为空",
    "k_f857b54e": "新流程要先保存，才能创建页面片",
    "k_7e87ddfc": "页面片保存失败",
    "k_f6ab003f": "页面片已经创建成功",
    "k_9269a45": "页面片创建完成 ",
    "k_47ce63fc": "是否新打开编辑页",
    "k_39ebf97f": "前往编辑",
    "k_88676045": "页面片已成功安装审批插件",
    "k_60dab208": "审批插件安装失败: {arg_0}",
    "k_2e01501": "添加页面片",
    "k_d12bdea3": "本流程其他节点",
    "k_356c5124": "其他流程",
    "k_1e157ff9": "编辑页面片",
    "k_a397e39e": "参数格式有误，必须是个JSON对象",
    "k_9f49859a": "参数已更新",
    "k_da0946ed": "添加缺少的默认参数：",
    "k_7083b8df": "删除未定义的参数：",
    "k_f5d97150": "查找不到ID为[{arg_0}]的流程单",
    "k_ad9271ca": "若不开启，则节点的调试功能将无效，并且启动后的流程无法作为调试存档点",
    "k_ebec0b5e": "调试模式",
    "k_cf0885d4": "立即启动",
    "k_85e973fe": "重置",
    "k_61cc4716": "查看流程单",
    "k_cd6bb72b": "从最近的流程导入",
    "k_ae400484": "设置流程启动参数",
    "k_4fdf5117": "流程已启动",
    "k_f60c46d5": "找不到流程数据",
    "k_cc29b924": "找不到被复制的流程数据",
    "k_2235ca79": "获取被复制的流程数据失败",
    "k_7a4ef58a": "已保存",
    "k_e1490b65": "检测到有变动，正在保存",
    "k_5e146065": "详询小助手",
    "k_f9b5f40f": "结束",
    "k_3753ac08": "通知渠道",
    "k_ed47e588": "未知的通知插件-",
    "k_3e526a83": "组件加载中...",
    "k_ded4b1fc": "流程单信息",
    "k_62ae4e14": "相关审批人",
    "k_686301fd": "流程名称",
    "k_cf9cd0fa": "项目ID",
    "k_f7170f3e": "流程状态（中文）",
    "k_ff8e2fee": "流程发起页面url",
    "k_81c2f47b": "流程版本号",
    "k_655aac6a": "流程状态",
    "k_c937df09": "流程消息",
    "k_3c5f9263": "发起流程的请求信息(headers和cookie)",
    "k_64a5d8c4": "发起流程时的HTTP请求头",
    "k_1ebd304c": "发起流程时的cookie对象",
    "k_84424589": "项目信息",
    "k_74d3cc0": "项目名称",
    "k_ca0be6f7": "共 {arg_0} 条数据",
    "k_9c96e49f": "申请人",
    "k_f69403f5": "申请时间",
    "k_58775278": "查看",
    "k_8adf95be": "调用数据源",
    "k_f6c24a2": "执行",
    "k_6e71bb32": "数据源接口集合",
    "k_521169b3": "获取请求参数",
    "k_37129eae": "启用错误处理分支",
    "k_c234e732": "开启后，请求出错将不会阻断整个流程，而是走错误处理分支",
    "k_73b298df": "需要进一步检查响应内容，判断是否真的成功",
    "k_3fadf68b": "如果你的服务响应，是通过返回 body 里的字段，标识是否成功，那请开启此功能并告诉我们如何判断是否成功",
    "k_28eb3eef": "自定义判断逻辑",
    "k_783bbd2a": "请求结果",
    "k_75869484": "包括响应头、响应数据等",
    "k_9deaf02e": "返回数据",
    "k_8336c54d": "返回头",
    "k_f509d599": "\n**http**类型数据源特有。\n\n**注意: 必须到数据源配置中「接口信息」>「透传响应头」配置需要获取的响应头。**\n              ",
    "k_32227cc9": "错误信息(出错时)",
    "k_23f11d1b": "对应节点配置中「参数」部分的 JavaScript 计算结果",
    "k_4d770db4": "DB数据源需要通过「检查响应内容」判断读写操作是否成功",
    "k_8938f41": "帮我配置",
    "k_f178f052": "编辑数据源",
    "k_8e36c985": "选择数据源",
    "k_f78e0060": "请选择接口",
    "k_a61675d5": "出错时，走自定义兜底逻辑",
    "k_effee207": "判断逻辑",
    "k_1dc8e8ec": "条件判断",
    "k_bda4d773": "判断条件",
    "k_8a42d7ea": "判断条件是否成立",
    "k_71d3564c": "是",
    "k_54a64727": "否",
    "k_243ab7aa": "发起其他流程",
    "k_abccc05b": "流程参数(JS表达式)",
    "k_efd0f805": "留空则使用当前流程的发起人",
    "k_45d85616": "等待流程执行结束",
    "k_b148121d": "如果不勾选，则会在发起后直接继续当前流程。\n\n无论是否等待，你都可以获取到发起的子流程的ID和URL",
    "k_404c87c9": "（发起后）流程单ID",
    "k_48255a57": "（发起后）流程单页面url",
    "k_dc69b9c3": "（发起后）实际流程参数",
    "k_b0a97ebd": "推送消息",
    "k_cebc2630": "输出日志",
    "k_d9e8a3e6": "输出",
    "k_b2f8ff7f": "在详情页显示",
    "k_a95f28e4": "详情页展示的表单",
    "k_1f96704e": "使用自定义页面片后，可以设计表单外观、自定义前端逻辑",
    "k_825a6006": "启用通知",
    "k_b29d481a": "通知人",
    "k_b3410f3": "通知配置",
    "k_b0fff121": "按权限",
    "k_682cde83": "按角色",
    "k_aa9703e4": "用户有以下权限之一",
    "k_c14ba0ce": "用户是以下角色之一",
    "k_56678614": "添加角色",
    "k_2ca306cf": "删除角色",
    "k_25cf2eb4": "将用户从以下角色中 {arg_0} ",
    "k_23af3c01": "鉴权",
    "k_e372f2e4": "权限",
    "k_f7430466": "用户",
    "k_141e46f5": "如发起人 job.creator 或指定某个用户 'user_01', 注意需要引号",
    "k_c6525f5e": "鉴权配置",
    "k_db9863ac": "失败",
    "k_86fd0a2e": "修改权限",
    "k_c713dbd6": "修改配置",
    "k_d2188f46": "成功",
    "k_b291195f": "重试计数器",
    "k_91e373e6": "重试次数",
    "k_814e6299": "注意：可能需要在「流程详情」里，配置「单节点最多重复运行次数」",
    "k_8c3820fe": "重试间隔(单位秒)",
    "k_53ddd97b": "自定义失败时行为",
    "k_b8e4e773": "如果不勾选，则在超过重试次数后，直接判定整个流程失败",
    "k_15dfc12d": "首次重试的时间",
    "k_62adad09": "剩余重试次数",
    "k_5cb3bb44": "记录了每次重试的时间",
    "k_4c2a5f01": "第几次重试",
    "k_d02940f4": "开始重试时间",
    "k_4230db11": "剩余{arg_0}次",
    "k_c8411d28": "超过了流程级的限制 {arg_0} 次！ ",
    "k_562a94e5": "调整限制",
    "k_1706d539": "发起流程的表单",
    "k_548340d": "可使用“页面片”定制发起流程的表单外观、自定义前端逻辑",
    "k_3d2e011b": "发起后，在流程单里隐藏",
    "k_d7837f70": "下一步",
    "k_91521b88": "表ID",
    "k_e53f25f0": "全量发布",
    "k_504646e4": "申请发布",
    "k_e4ff5404": "灰度发布",
    "k_7296fb49": "撤下灰度",
    "k_10c4405d": "申请回滚",
    "k_63f2ff1a": "回滚灰度",
    "k_149b5bd2": "调用版本接口",
    "k_9e6baf1": "配置信息",
    "k_3e423e67": "表版本",
    "k_cbf676a3": "行版本",
    "k_e0feb926": "动作",
    "k_91eda872": "启用错误处理(error)分支",
    "k_7027df19": "开启后，请求出错将不会阻断整个流程，而是走错误处理分支。",
    "k_558d0dff": "结果",
    "k_7863632c": "调用版本接口的响应",
    "k_1d5adde3": "Webhook",
    "k_ebf1d54f": "Hook标识",
    "k_e2e87955": "用于生成 WebHook 的 URL。外部系统通过POST数据到这个地址即可继续流程：\n`{arg_0}`",
    "k_41c1d065": "返回出去的数据",
    "k_b42ca206": "{\n  // 可以按需返回数据给调用方\n}",
    "k_25acabb2": "接收到的数据",
    "k_416999b9": "获取绑定列表失败",
    "k_6aec0382": "获取权限列表失败",
    "k_6224331b": "无权更新，只读模式",
    "k_a2fd9dd6": "无权查看",
    "k_970a22ed": "数据源接口",
    "k_acac53db": "云函数接口",
    "k_cd41af47": "输入数据源ID进行搜索",
    "k_4bf257ee": "输入接口名进行过滤",
    "k_5075404c": "权限申请",
    "k_4f80e736": "申请",
    "k_12dfe79b": "审批权限申请流程",
    "k_4ad83ff3": "驳回",
    "k_1c76407b": "你不是审批人之一，无法审批；但管理员可重新指派",
    "k_fbcda0d0": "请选择或搜索审批人",
    "k_5fa63f3c": "指派审批人",
    "k_3c8f8c7e": "请先选择审批人再指派",
    "k_cc570dc7": "指派成功",
    "k_edb405d4": "指派审批人失败",
    "k_d1554fe": "同意操作，角色不能为空",
    "k_f07c490a": "审批失败",
    "k_43927821": "权限项",
    "k_a3896355": "申请类型",
    "k_c3253889": "申请页面权限",
    "k_db6346cf": "申请角色",
    "k_c3ff1411": "搜索无结果",
    "k_ad31a0d5": "无可申请角色",
    "k_dfd14bd4": "内置角色不可被申请",
    "k_60e41b61": "基于上下文推荐申请以下角色",
    "k_7d445d30": "请联系管理员",
    "k_6c172fde": "其他角色（以下角色没有上下文需要的权限）",
    "k_73d54654": "点击查看角色权限：",
    "k_3f7e7eb4": "申请说明",
    "k_79075b4f": "描述正在进行的操作，便于管理员分配恰当的角色",
    "k_f56d22cf": "额外表单",
    "k_927e6858": "查看应用数据",
    "k_11b2b861": "新建应用数据",
    "k_c6fb6df9": "更新应用数据",
    "k_9c7d76b4": "删除应用数据",
    "k_55b9b537": "更新数据",
    "k_17f2bda6": "删除数据",
    "k_6d1600bb": "查看权限配置",
    "k_85e85418": "更新权限配置",
    "k_11a23dba": "在流程中上传",
    "k_d31fd601": "用户申请的角色不存在",
    "k_13a91368": "获取角色列表失败",
    "k_a4da5574": "用户申请的角色没有相关的权限",
    "k_3df86315": "获取权限-角色失败",
    "k_2137271f": "申请角色或页面不能为空",
    "k_ba41f4a3": "申请说明不能为空",
    "k_9e7792ce": "校验额外表单失败, {arg_0}",
    "k_8e48113f": "找不到审批人，请联系管理者",
    "k_9a892c89": "最多只能选择 5 个{arg_0}",
    "k_ef59f997": "权限ID",
    "k_2cb77faf": "批量授权应用中所有页面，谨慎使用",
    "k_bbfd0426": "权限名",
    "k_b20393ca": "持有权限",
    "k_858aa2": "请输入权限名进行搜索",
    "k_4e598ff3": "检测权限失败",
    "k_61b4497e": "角色成员",
    "k_df24a06c": "关联角色",
    "k_e6e5601f": "检测权限",
    "k_6b30db70": "相关页面",
    "k_c9e3f880": "检测",
    "k_b5d17cb6": "第三方鉴权",
    "k_92693add": "平台配置-运行时自定义鉴权",
    "k_1af095c3": "检测用户权限失败",
    "k_57ae3ac7": "盘古",
    "k_2721cd30": "✅ 持有权限",
    "k_9abe0fa1": "🚫 无权限",
    "k_94d935c0": "用户有管理员身份",
    "k_2a06b507": "管理员身份可能来自：应用信息里的管理者、开发环境的开发者，或权限管理里的管理员角色成员、或应用组管理者等",
    "k_1b025b35": "鉴权来源",
    "k_3cde56a8": "鉴权结果",
    "k_6179350d": "检测用户权限",
    "k_771586f6": "相关业务",
    "k_e0ecb787": "选择隔离业务",
    "k_7cb8521": "快速选中:",
    "k_eb0ffa9": "我的部门",
    "k_709591a0": "我的小组",
    "k_95f5015": "自定义环境",
    "k_e73156ed": "不相关",
    "k_d7ae1934": "请输入页面名称或路径进行搜索",
    "k_1e0fdae0": "页面标签筛选",
    "k_2ffa6b72": "仅显示有权限的页面",
    "k_17bfa636": "概览",
    "k_25ddb22b": "页面视图",
    "k_29c1d5f2": "权限集合",
    "k_c7ff41cd": "已新增权限: {arg_0}",
    "k_cb52390a": "已删除权限: {arg_0}",
    "k_ac447102": "已新增角色权限",
    "k_bb4f0f51": "已删除角色权限",
    "k_1c9572f8": "更新失败",
    "k_e865cd7": "流程权限",
    "k_fb041422": "自定义接口/集合权限",
    "k_6a1786be": "内置页面权限",
    "k_88a141db": "自定义页面权限",
    "k_3613c3e7": "点击可显示全部（包括已过期的）",
    "k_591f556d": "切换所属业务",
    "k_f24a3eaa": "平台(业务无关)",
    "k_a04a048e": "平台",
    "k_1ddbcd9b": "应用类型角色，业务无关",
    "k_56da1ba6": "扩展字段必须是合法的 JSON 字符串",
    "k_446e6b00": "扩展字段必须是一个对象",
    "k_ce6969a7": "扩展字段不能包含受保护的字段：{arg_0}",
    "k_665bd9ee": "请到角色里管理该权限，进而让角色成员获得权限",
    "k_b5937989": "有效字符：英文字母、数字、下划线、\"/\"以及\"-\"",
    "k_b494c015": "权限重复",
    "k_5c1ee823": "必填",
    "k_3b80d08c": "最大长度 128",
    "k_367572ca": "最大长度 36",
    "k_4a4ffe": "唯一标识",
    "k_fd3353cc": "扩展字段",
    "k_cf56c2b": "权限类型",
    "k_1124f650": "权限名称",
    "k_22bb085": "关联页面",
    "k_bf45c68a": "不填则关联所有页面",
    "k_9fe735f7": "请选择关联页面，不填则可在所有页面上使用",
    "k_e39e29f1": "确认删除当前权限？",
    "k_fc886eae": "注意：同时会删除绑定，如角色-权限，接口-权限",
    "k_318e6052": "管理关联",
    "k_a9439afa": "更多",
    "k_cc7543f3": "删除权限",
    "k_1612ef2e": "确认删除该接口关联？",
    "k_295194b8": "接口：{arg_0}",
    "k_f0a05caa": "点击X删除关联接口",
    "k_4777816a": "关联云函数 (",
    "k_c4b14d3e": "关联数据源 (",
    "k_820919a0": "同步权限",
    "k_69b0a078": "请输入权限名搜索",
    "k_a4195300": "编辑权限",
    "k_2752769": "同步权限配置",
    "k_458ebfa7": "管理云函数接口",
    "k_9884f1e5": "管理数据源接口",
    "k_838046a2": "已关联",
    "k_7eb6dd7c": "关联云函数",
    "k_989b2cca": "关联数据源接口",
    "k_96aa130e": "权限数据环境隔离，当前环境：{arg_0}",
    "k_85fd4c96": "未完成初始化，暂不支持在无极侧管理，请自行到盘古侧管理配置",
    "k_7833783a": "点击前往盘古",
    "k_be264c8b": "角色管理",
    "k_66b1d735": "用户管理",
    "k_e14286c": "自定义权限管理",
    "k_3350e5ed": "接口管理",
    "k_1091a552": "请输入{arg_0}进行搜索",
    "k_b62b76f3": "角色类型",
    "k_f4b9d1ce": "应用",
    "k_e0a0bc00": "未启用业务隔离",
    "k_7dacca34": "角色ID",
    "k_8a91f80a": "例如：admin-group",
    "k_7c6fcd47": "角色名",
    "k_506e847d": "例如：管理组",
    "k_6381b181": "有效字符：英文字母、数字、下划线以及\"-\"",
    "k_15605837": "角色重复",
    "k_5e2c6855": "- 无效组织，组织ID或已变更",
    "k_ea042cd3": "确认删除当前角色？",
    "k_988201b7": "注意：同时会删除所有关联用户",
    "k_6118ed64": "管理用户/组织",
    "k_5d2c15a5": "由系统自动维护",
    "k_840692fa": "角色为业务类型，但应用没有启用业务隔离",
    "k_bb419b65": "添加用户",
    "k_c2a13176": "删除用户",
    "k_36902a80": "暂未对接盘古组织",
    "k_ab2a318f": "添加组织",
    "k_e063159d": "删除组织",
    "k_cf2601eb": "内置角色",
    "k_4b6883f0": "关联用户/组织",
    "k_96a82d76": "未登录的访客",
    "k_12f6d40a": "所有已登录的用户",
    "k_8163e8ec": "所有用户",
    "k_49c11246": "管理权限",
    "k_f27fc1d1": "角色已锁定",
    "k_21a6dc55": "管理角色",
    "k_3debb283": "修改角色名",
    "k_febf41c1": "带业务隔离的权限",
    "k_b21d1a08": "{arg_0} (点击复制)",
    "k_832f8120": "已复制 {arg_0}",
    "k_a766ebf7": " 权限",
    "k_23d73def": " 成员",
    "k_ab7e00c7": "获取角色和权限信息失败",
    "k_2802155d": "{arg_0}环境尚未发过版本",
    "k_f69f1c55": "生成申请流程成功",
    "k_99bf2bd0": "生成申请流程失败",
    "k_8dfabb10": "确认生成自定义申请流程？",
    "k_b4765ff6": "权限申请流程默认由平台提供",
    "k_2b429fda": "生成自定义申请流程后，可以",
    "k_228b7004": "修改审批人，默认审批人为应用管理员角色",
    "k_32ecb2e": "自行添加申请成功钩子",
    "k_6b5cf2cd": "如无以上需求，使用平台提供的申请流程即可",
    "k_62b40ffd": "确认",
    "k_505c7efb": "同步角色配置",
    "k_81ccf1c3": "权限申请设置",
    "k_b29e29fa": "点击查看",
    "k_b4c528a9": "点击生成",
    "k_20f5996e": "平台级别自定义鉴权启用，在这里配置无效",
    "k_5016f531": "第三方鉴权启用，在这里配置无效",
    "k_ac3c2a7e": "搜索角色",
    "k_5d1fdb0a": "请输入角色ID或角色名关键字",
    "k_b53e6a5d": "编辑角色",
    "k_eeb40c47": "管理{arg_0}",
    "k_9edd2518": "组织",
    "k_bd790946": "权限申请设置{arg_0}",
    "k_6f08ec45": " - 非开发环境，只读",
    "k_18212795": "以下配置均需要通过发版才能在其他环境生效",
    "k_a9d5d5a4": "自定义权限申请流程",
    "k_422a9045": "若无，则使用内置权限申请流程",
    "k_c7b54ff7": "禁止申请页面权限",
    "k_cf7f0d44": "申请页面查看权限，平台将会自动生成 /page-path 角色，该角色权限只有该页面的查看权限，无法变更",
    "k_ee6711b2": "申请角色模式",
    "k_c3881116": "用户申请多个角色时，是合并成一条审批单还是拆分成一个角色一个审批单",
    "k_868b8564": "拆分",
    "k_a9ac2ed5": "所属业务不能为空",
    "k_be32bbaf": "添加用户({arg_0})失败: {arg_1}",
    "k_12ef0f98": "添加{arg_0}失败",
    "k_a4e6ed1c": "删除{arg_0}失败",
    "k_d1a100c8": "确定删除{arg_0}？",
    "k_e8019f3f": "将删除{arg_0}: ",
    "k_80bbede4": "所属业务",
    "k_8b404cd2": "当前关联{arg_0}",
    "k_8aeb6cd9": "添加{arg_0}",
    "k_c5ded26a": "删除{arg_0}",
    "k_79c6d62b": "目标环境未启用 POWER 鉴权，无法同步",
    "k_cf6d8710": "目标环境未启用只读模式，无法同步",
    "k_4508397f": "同步成功",
    "k_f602515f": "同步失败",
    "k_a48a27a4": "正在同步中，请稍后",
    "k_763d3b0a": "选择环境",
    "k_6a6baed3": "同步到环境",
    "k_cc37f9a3": "开始同步",
    "k_1c32d762": "同步中",
    "k_67b79fe0": "同步结束",
    "k_dce7ec06": "无权查看 {arg_0} 环境",
    "k_1bca45a4": "获取{arg_0}列表失败",
    "k_37dd0b49": "无权更新目标环境",
    "k_62b0dd47": "获取",
    "k_5384ba5": "接口绑定权限",
    "k_c121fec1": "角色权限",
    "k_b36a7ea3": "角色用户",
    "k_a4be3f9c": "失败，或已存在",
    "k_22a5075": "成功同步权限配置 {arg_0}",
    "k_c7edc36d": "同步权限配置 {arg_0} 失败",
    "k_54e5c418": "成功同步角色配置 {arg_0}",
    "k_d9b8a867": "同步角色配置 {arg_0} 失败",
    "k_f527168f": "将会同步权限、接口类型权限绑定的接口关系、及集合相关权限",
    "k_967a19fc": "也可以通过「同步角色配置」连带权限进行同步",
    "k_fa9223ef": "将会同步角色、权限、角色-权限绑定及接口类型权限绑定的接口关系",
    "k_1c74311f": "不存在的权限会同步新建到目标环境，但相关页面或数据源请自行通过发布版本到目标环境",
    "k_63bbf1c7": "需要同步的权限",
    "k_f8b0f20d": "需要同步的角色",
    "k_e2ca8af9": "同步角色-用户",
    "k_c4f2f5e4": "不会删除目标环境里的现存用户",
    "k_b1ce8b48": "同步结果",
    "k_d267b42b": "查看结果",
    "k_f4003f7d": "确认移除当前用户/组织？",
    "k_b30ecd36": "注意：同时会删除所有关联角色",
    "k_fe4c3f86": "已移除",
    "k_9a143067": "到期时间",
    "k_50336413": "移除{arg_0}",
    "k_46ae8222": "批量更新过期时间",
    "k_f49e8c60": "请输入名称搜索",
    "k_7649b341": "添加角色({arg_0})失败: {arg_1}",
    "k_f6594213": "添加角色失败",
    "k_7907628d": "删除角色失败",
    "k_3e84d0f6": "确定删除角色？",
    "k_e31c4c0a": "将删除角色:",
    "k_a8c335b2": "用户已存在",
    "k_c5ca71a": "应用类型角色",
    "k_4d6c5b12": "集合",
    "k_f6e68ca8": "一般用于设置 UI 可见性",
    "k_8f71bb05": "可设置关联页面，页面级别权限，属于「页面权限」",
    "k_dc7d645c": "可绑定数据源接口, 绑定后用户调用接口须有该权限；也可以不绑定接口，作为应用级别权限使用",
    "k_dbd89e4e": "可设置该权限代表的权限集合，方便赋权",
    "k_9fbdbc0a": "是否允许数据源接口通过 “MCP 代理” 调用",
    "k_72288ae6": "查看页面数据",
    "k_d27542c4": "新建页面数据",
    "k_f6f2bdda": "更新页面数据",
    "k_31802b06": "删除页面数据",
    "k_7a6784c1": "上传",
    "k_a6db7578": "查看页面数据，可以在对应页面调用数据源接口: get/list/count/request/custom_*",
    "k_77114af3": "继承自内置权限：查看应用数据",
    "k_d398b57f": "新建页面数据，可以在对应页面调用数据源接口: create",
    "k_541cf25b": "继承自内置权限：新建应用数据",
    "k_9bdfd184": "更新页面数据，可以在对应页面调用数据源接口: update",
    "k_7f12cdee": "继承自内置权限：更新应用数据",
    "k_222b9012": "删除页面数据，可以在对应页面调用数据源接口: delete",
    "k_3a988fdd": "继承自内置权限：删除应用数据",
    "k_755292ba": "可以在页面使用上传组件",
    "k_c0a30a4d": "继承自内置权限：上传应用数据",
    "k_b2173608": "天内到期",
    "k_59eae679": "已过期",
    "k_8f2599df": "天",
    "k_42dac712": "获取云函数列表失败",
    "k_58da5ae2": "获取数据源接口失败",
    "k_c6ae8625": "获取角色用户列表失败",
    "k_4328b559": "无权查看当前环境权限配置",
    "k_1165ae17": "对应环境疑似未发版，请先发版再访问",
    "k_65eae92e": "已绑定权限",
    "k_f577e9b3": "无 -",
    "k_8455430a": " 绑定权限",
    "k_e4a923d2": " 解绑权限",
    "k_57f2457d": "绑定成功",
    "k_45422fa6": "绑定失败",
    "k_c381d36": "绑定权限",
    "k_2d39d920": "选择权限",
    "k_9d437070": "备注",
    "k_32686149": "获取数据源列表失败",
    "k_2e882e3c": "默认绑定页面的\"{arg_0}\"权限",
    "k_6be2405": "默认没有权限控制",
    "k_ac8ea015": "解绑成功",
    "k_43f5dcff": "解绑失败",
    "k_f5fa441e": "解绑权限",
    "k_4ed64ded": "选择需要解绑的权限",
    "k_f170ea29": "用户/组织名",
    "k_f84e8c1b": "已过期禁用",
    "k_68f6ba4e": "生效中",
    "k_3b810880": "永不过期",
    "k_5b99febb": "设置过期时间成功",
    "k_eb75e1fe": "设置过期时间失败",
    "k_312ec4": "设置过期时间",
    "k_d35f100a": "已选中",
    "k_bf62315e": "项",
    "k_8d9ea3bf": "用户或组织过滤",
    "k_c051292e": "7 天内过期",
    "k_2cf32537": "30 天内过期",
    "k_bb82dfb7": "共 {arg_0} 项",
    "k_d2f7f39c": "平台(应用类型角色)",
    "k_15302aab": "不限期",
    "k_9ea6fc4": "已添加全部角色",
    "k_d9d812e3": "批量设置到期时间",
    "k_7513f654": "1天",
    "k_f734062a": "3天",
    "k_131310c7": "1月",
    "k_bfd19c35": "3月",
    "k_9d176e6b": "1年",
    "k_9b86e407": "{arg_0}是{arg_1}员工\n      ,有效期最长{arg_2}天",
    "k_d231a3d0": "有效期",
    "k_81c27da2": "{arg_0}天",
    "k_c6ee5945": "无权限",
    "k_aa33ccce": "您不是应用组管理员",
    "k_e1acdad0": "我的申请",
    "k_ee0e8193": "已办审批",
    "k_36cc3223": "相关审批",
    "k_354a100f": "全部审批",
    "k_6e523f39": "撤销",
    "k_1adc5b73": "审批重试",
    "k_9f61b23a": "重新发起审批",
    "k_8238b019": "通知插件禁止默认的审批操作, 请审批人在「 {arg_0} 」侧审批 ",
    "k_3035f068": "单据不存在或无权访问",
    "k_477eef46": "获取审批单失败",
    "k_f4382985": "获取审批单记录失败",
    "k_5e9ec25d": "确定撤销当前流程单？",
    "k_be2f741e": "说明",
    "k_836a1c78": "撤单失败, {arg_0}",
    "k_1faeb29a": "确定重试审批执行钩子失败的节点？",
    "k_556976ba": "将会在失败节点上重新执行相同的审批操作，若节点上配置有多个钩子接口，无论之前已经执行成功或失败，都会再次执行",
    "k_660dcfac": "失败节点：{arg_0}({arg_1})",
    "k_a4bea126": "重试失败, {arg_0}",
    "k_601599de": "重新发起审批失败, {arg_0}",
    "k_b5a4f64e": "没有找到审批配置",
    "k_12a3fd60": "确定重新发起审批？",
    "k_ce306f0f": "检测到当前审批配置没有关联发起流程页面，无法修改审批数据，将用原审批数据重新发起",
    "k_481bdccc": "审批单详情",
    "k_1217471a": "拉取页面数据失败：{arg_0}",
    "k_92b5434d": "获取流程配置失败",
    "k_d08e2a04": "流程配置",
    "k_beb157fe": "审批中",
    "k_7d27843f": "已通过",
    "k_227d6ef6": "已驳回/流程失败",
    "k_4e2676db": "基础审批",
    "k_9f607cb7": "高级审批",
    "k_3b1a251e": "同意所选( {arg_0} ) ",
    "k_1a164baa": "驳回所选( {arg_0} ) ",
    "k_4112a5d9": "预览",
    "k_cf8cccf9": "当前节点",
    "k_557de6d3": "已撤销(abort)",
    "k_f77e6774": "单据状态",
    "k_a4640b30": "已驳回",
    "k_14a0c668": "流程失败",
    "k_8493b107": "已撤销",
    "k_64f650a2": "未知状态",
    "k_bef02fc6": "发版审批",
    "k_7b3dba83": "获取流程配置列表失败",
    "k_3c8705cb": "获取流程实例失败",
    "k_8d055376": "批量审批确认",
    "k_69cfcf4c": "确认{arg_0}已选中的 {arg_1} 条流程单？",
    "k_184305b3": "确认{arg_0}",
    "k_c1fab51e": "批量审批已处理，但部分流程执行失败",
    "k_e10b504d": "批量审批成功",
    "k_6a290277": "批量审批失败",
    "k_ad04346b": "{{ state.pageTitle || \"流程实例详情\" }}",
    "k_21d16af2": "你访问的页面貌似不存在？",
    "k_201400b1": "返回首页",
    "k_dffafaaa": "获取审批列表失败",
    "k_29ec9120": "获取审批流失败",
    "k_9993c650": "发起的审批有误",
    "k_8c5c19ad": "AI页面区域",
    "k_7146ef43": "运行时将渲染 {arg_0} ",
    "k_bf58c1d8": "无法加载当前页面，缺少页面id定义",
    "k_5efa22f5": "页面新版本已发布",
    "k_8e45119b": "您可以点击或者刷新页面以体验！🚀🚀🚀",
    "k_6889c4": "检查权限失败",
    "k_b9fcd07e": "是否确认取消应用关联数据库?",
    "k_956b208a": "取消应用关联数据库可能会影响其他页面的数据源, 请谨慎操作",
    "k_23261ba8": "编辑数据表页面",
    "k_3d99548b": "编辑页面信息",
    "k_3310014e": "新建页面",
    "k_4a1dd98": "复制页面",
    "k_2caf5ae8": "页面信息",
    "k_ad53b5ff": "不再提示",
    "k_b9032647": "请在打开的页面中使用组件",
    "k_f284640b": "，查看调试结果",
    "k_689bb658": "在本编辑器中，点击保存按钮（或者按下ctrl/cmd + s），会触发调试页面的更新",
    "k_c3a86ce7": "请注意：不要刷新调试页面，不然会导致热更新失效。",
    "k_45ec49bc": "添加的页面类型错误!",
    "k_1283768d": "请选择{arg_0}页面",
    "k_b324687a": "{arg_0}页面",
    "k_fdfa555f": "获取应用的短路径配置失败",
    "k_739fe5ff": "删除短路径配置失败",
    "k_da32f263": "任务失败，请重新导出",
    "k_37f838ab": "等待任务导出完成...",
    "k_1d427ca9": "下载链接为空，无法下载",
    "k_d46fd381": "进行中",
    "k_1c40e30e": "页面停留时长",
    "k_4371425a": "元素点击",
    "k_6962e060": "元素曝光",
    "k_64ca60e6": "元素行为",
    "k_8768cf20": "除 “元素点击” 事件外的其他组件行为事件（比如切换选项卡，行为ID需填 “${组件ID}:${事件ID}”）",
    "k_b2aa654": "总访问次数",
    "k_5d38c887": "总访问人数",
    "k_7f3cbb3": "人均次数",
    "k_82f3a35e": "停留时长[平均值:秒]",
    "k_7b01390f": "停留时长[最大值:秒]",
    "k_55902551": "扩展字段{arg_0}",
    "k_179d1d10": "组件路径",
    "k_82815987": "离线任务",
    "k_22d72976": "获取应用和页面数据失败: {arg_0}",
    "k_357199e2": "当前页面为低代码开发，不支持此模式",
    "k_2065fc89": "缺少nodeId",
    "k_a2c36ef2": "创建离线任务",
    "k_62e08b15": "删除离线任务",
    "k_870042dc": "创建离线化配置",
    "k_2ff967f1": "更新离线化配置",
    "k_183bdc94": "删除离线化配置",
    "k_18a7c2a3": "调试离线化配置",
    "k_3a4f81ec": "这个部署版不支持获取部门信息",
    "k_aafffa70": "获取项目公告列表失败: {arg_0}",
    "k_efd4b918": "已删除公告",
    "k_7a29cb40": "删除公告失败: {arg_0}",
    "k_38a75fb4": "已更新公告",
    "k_56b62098": "更新公告失败: {arg_0}",
    "k_9eddd076": "已创建公告",
    "k_9680db30": "创建公告失败: {arg_0}",
    "k_3e3d2e52": "获取项目走马灯公告列表失败: {arg_0}",
    "k_14ff5e3c": "修改已读状态失败: {arg_0}",
    "k_e216071d": "获取公告数据失败",
    "k_e69577b9": "获取公告记录失败",
    "k_e901db9d": "获取组件模版列表失败{arg_0}",
    "k_e4c77d2d": "获取组件模版失败",
    "k_853fb3ad": "模板更新成功",
    "k_b59111d3": "模板创建成功",
    "k_f5bb2eff": "获取可管理的组件模版列表失败",
    "k_979fce5f": "模板删除成功",
    "k_912c9ac0": "模版删除失败",
    "k_db8fa218": "默认商店",
    "k_f5bd66e0": "正式环境",
    "k_fdfa33f5": "获取应用环境列表失败",
    "k_7d2a4507": "该环境已被系统使用，请设置另外一个环境id",
    "k_dbed5abc": "拉取物料数据失败：{arg_0}",
    "k_cd21075e": "获取离线列表失败",
    "k_aef0b066": "获取历史版本号失败",
    "k_1d23083": "离线任务创建成功",
    "k_eaa3c7e2": "离线任务创建失败: {arg_0}",
    "k_e13b3a97": "已删除离线记录",
    "k_798309b1": "删除离线记录失败: {arg_0}",
    "k_25d9ce9b": "获取离线化配置列表失败",
    "k_9ac58b33": "离线化配置创建成功",
    "k_ab483881": "离线化配置创建失败: {arg_0}",
    "k_3a097bcf": "离线化配置更新成功",
    "k_8c0e0401": "离线化配置更新失败",
    "k_66babe8c": "离线化配置更新失败: {arg_0}",
    "k_5bf9626b": "已删除离线化配置: {arg_0}",
    "k_bc2291a3": "删除离线化配置失败",
    "k_222dc84d": "删除离线化配置失败: {arg_0}",
    "k_f44c3046": "配置函数调试成功",
    "k_55cbc7d2": "配置函数调试失败",
    "k_99a934d1": "配置函数调试失败: {arg_0}",
    "k_a38b4eaa": "获取插件列表失败",
    "k_983270d": "本地debug的插件不支持卸载",
    "k_b1701ec2": "获取id为{arg_0}的修改记录失败: {arg_1}",
    "k_792038cb": "获取{arg_0}类型修改记录列表失败: {arg_1}",
    "k_45766415": "保存{arg_0}类型修改记录失败: {arg_1}",
    "k_dfdd7274": "[getPageDetail] JSON.parse 失败",
    "k_59996f07": "无极默认皮肤",
    "k_3b186ae3": "返回数据为空",
    "k_ae787d88": "获取皮肤失败",
    "k_3e9f8ce9": "获取皮肤数据失败 {arg_0}",
    "k_19909fc1": "无法获取皮肤 {arg_0}",
    "k_6bf8ff99": "获取皮肤demo页面失败",
    "k_4c99299a": "获取应用模版列表失败{arg_0}",
    "k_71fb6c9e": "获取自定义应用模版列表失败{arg_0}",
    "k_5311e214": "获取应用模版{arg_0}失败:{arg_1}",
    "k_d65783ce": "{arg_0} 环境暂未发布版本，当前无可比较的版本",
    "k_7d0bf4f5": "获取当前页面版本差异失败:{arg_0}",
    "k_332aaa52": "提交版本失败:{arg_0}",
    "k_4b6567de": "获取版本列表失败:{arg_0}",
    "k_3712f46e": "发布版本失败:{arg_0}",
    "k_a397ab58": "获取当前应用版本列表失败:{arg_0}",
    "k_62099491": "同步环境数据失败:{arg_0}",
    "k_4d4fb2fe": "获取版本发布内容失败",
    "k_155ae064": "版本终止失败:{arg_0}",
    "k_37bbc2f3": "操作失败{arg_0}",
    "k_8ae82c14": "导入成功",
    "k_14533a37": "导入失败: {arg_0}",
    "k_6155e57b": "执行前置钩子失败: {arg_0}",
    "k_ef623dfe": "获取导入钩子失败: {arg_0}",
    "k_1b53325a": "分支名称不能为空",
    "k_b8fdcc77": "获取分支列表失败",
    "k_28718a38": "获取分支信息失败",
    "k_78c193e9": "自动切换到开发分支",
    "k_931968db": "获取用户当前开发分支失败",
    "k_f1727d44": "即将切换至 {arg_0} 分支",
    "k_580147f2": "切换分支失败",
    "k_d1f925cf": "获取未提交变更失败",
    "k_e76f0e39": "获取提交记录失败",
    "k_88e18551": "获取分支最新版本失败",
    "k_50654f3b": "拉取失败:{arg_0}",
    "k_33583bab": "已合并过master的最新提交",
    "k_1768046a": "没有可{arg_0}的提交",
    "k_877674a6": "合并失败:{arg_0}",
    "k_c1fc01d2": "重置提交操作失败",
    "k_782fc1ea": "获取数据表列表失败：{arg_0}",
    "k_4b1ce09b": "获取修改记录失败{arg_0}",
    "k_e65e9d6c": "页面操作请求参数错误",
    "k_8515267d": "获取页面列表失败",
    "k_6195cfa3": "合并页面修改冲突失败, 取消保存",
    "k_bc9e2cec": "检测应用ID失败",
    "k_9c6cf492": "拉取应用数据失败：{arg_0}",
    "k_ffa21796": "切换项目获取数据失败：{arg_0}",
    "k_1abf81d9": "合并应用修改冲突失败, 取消保存",
    "k_616bb31c": "保存成功 (已合并本地落后的远程修改)",
    "k_9744f625": "获取应用设置失败:{arg_0}",
    "k_e0195c74": "获取权限设置失败:{arg_0}",
    "k_8e4e6eb3": "获取应用组的应用列表失败",
    "k_19c27af2": "拉取应用是否更新数据失败：",
    "k_42b6f862": "拉取应用是否更新数据失败：{arg_0}",
    "k_78b196a9": "更新应用数据失败：",
    "k_80303a7e": "更新应用数据失败：{arg_0}",
    "k_8827f9cc": "请键盘按下",
    "k_4feb17b1": "以粘贴内容",
    "k_fe0b5061": "取消粘贴",
    "k_671ea1f5": "无响应",
    "k_66080238": "响应内容有误",
    "k_7fc10dac": "loadAmdModule 函数调用缺少必要的 amdKey 参数",
    "k_7bfb9758": "平台组件",
    "k_f3172a27": "[componentHubStore] 加载组件商店信息失败",
    "k_36624eac": "默认主键",
    "k_a3d7608b": "{arg_0} 数据源解析失败, 请检查授权数据库的配置",
    "k_139ed9ba": "导出失败: {arg_0}",
    "k_6a865080": "无权调用",
    "k_760521f2": "无权发起流程，点击",
    "k_bfacb6f4": "公开应用不允许修改数据，只允许读取数据",
    "k_7dd1a08e": "请求超时",
    "k_754eb533": "请求失败: code={arg_0}, msg={arg_1}",
    "k_d4e420d": "应用 LessCode 执行失败, 请校验应用级 LessCode 代码",
    "k_63eb452e": "获取cookie失败：{arg_0}",
    "k_e7967770": "Monaco Editor 加载失败[{arg_0}]",
    "k_6fb558f5": "打开编辑器失败：缺少应用 ID 或页面 ID 参数",
    "k_cd065d21": "打开编辑器失败：页面不存在",
    "k_9e5074ae": "页面/链接跳转失败: {arg_0}",
    "k_7dabc5c0": "无效页面路径",
    "k_2064a310": "路径解析失败: 动态路径参数不能为空",
    "k_f6c43c82": "动态路径解析失败",
    "k_a5cfd0b9": "文件名不能包含中文字符",
    "k_95610e57": "应用信息",
    "k_e852b234": "发布管理",
    "k_eb8e4960": "授权",
    "k_506326d2": "日志 | 数据",
    "k_f5ed4e00": "权限管理",
    "k_dbeaa94e": "设置",
    "k_fb10ca0": "页面列表",
    "k_4f007a55": "添加页面",
    "k_686d8fb2": "标签管理",
    "k_98aed9be": "通用配置",
    "k_295efc94": "应用ID",
    "k_20cba5c": "应用中文名",
    "k_409f2431": "描述",
    "k_5a4ecbd5": "运营产品",
    "k_9d32cc23": "管理者",
    "k_263d97ff": "开发者",
    "k_c193dc90": "页面主题色",
    "k_9a83c869": "设计风格",
    "k_a7863779": "默认布局风格",
    "k_e4a17591": "应用图标",
    "k_bd4dd7ef": "应用图标同时用于导航栏、应用列表卡片与浏览器标签页显示",
    "k_8a679250": "首页",
    "k_92841cb4": "应用首页和根路径(/)重定向的页面; 支持配置页面路径为 / 的页面作为应用默认首页",
    "k_ad62fe85": "403 重定向",
    "k_a28cc400": "请求接口返回 403 时重定向的页面",
    "k_12b8abc6": "隐藏页面进度条",
    "k_2c18c818": "是否隐藏页面顶部的加载进度条",
    "k_49de27d7": "消息提醒样式",
    "k_7cd6e7cc": "定义页面运行时的错误消息如何展示，默认是“通知浮层”",
    "k_24106a88": "水印功能",
    "k_e94bfcd9": "这里开启的是全局水印功能(所有页面生效), 如果希望单个页面生效请到页面中单独设置",
    "k_cf117737": "小满反馈",
    "k_f50a9b5a": "这里开启的是正式环境的小满功能。",
    "k_5b4ffd97": "小满是一个满意度反馈的平台，其中小满ID是您的管理平台的唯一ID。",
    "k_31263a7f": "需要了解小满相关内容及生成小满ID可前往小满官网。",
    "k_c2d9342c": "前端监控",
    "k_59ee9f84": "这里开启的是平台内置的运行时前端监控。",
    "k_552e0834": "开启有助于平台更快速定位具体问题",
    "k_c01eb690": "代理上报",
    "k_71a3695f": "默认为关闭, 运行时使用前端直接上报",
    "k_114720f6": "开启时, 运行时使用后台代理上报",
    "k_812ef8c4": "站内公告",
    "k_e859a2e0": "这里开启的是编辑时站内公告配置，以及运行时站内公告展示",
    "k_d897b344": "应用导航",
    "k_ff847a4c": "应用导航为运行时所有页面的导航配置, 优先级低于页面的单独配置",
    "k_f89e924a": "应用菜单",
    "k_25512510": "应用菜单为运行时所有页面的菜单配置, 优先级低于页面的单独配置",
    "k_fcd32904": "应用页头",
    "k_11f715eb": "应用页头为运行时所有页面的页头配置, 优先级低于页面的单独配置",
    "k_64c881e7": "应用页脚",
    "k_a801cdc0": "应用页脚为运行时所有页面的页脚配置, 优先级低于页面的单独配置",
    "k_2dfa9b23": "可见范围",
    "k_c05af489": "扩展配置",
    "k_6293d5c1": "自定义布局组件配置",
    "k_497ac1f1": "全局路由守卫",
    "k_82d3fe18": "企业微信应用配置",
    "k_e2880003": "应用 LessCode",
    "k_65497236": "全局脚本配置",
    "k_996f55a6": "全局图标配置",
    "k_130a364d": "前端监控配置",
    "k_9a2ca24a": "顶部导航",
    "k_cd480ec5": "用户信息",
    "k_1cba5fce": "应用名称",
    "k_4e0f78e9": "应用Logo",
    "k_2f969c12": "帮助文档",
    "k_86ef7db0": "我要反馈",
    "k_5ab53ef0": "应用快捷切换面板",
    "k_ddc2a038": "固定头部导航",
    "k_f7a98f36": "显示页面层级关系",
    "k_3a05b280": "在导航下面使用面包屑来展示页面的层级关系，示例：<br/>",
    "k_70cc46df": "一级目录 / 二级目录 / 页面xxx",
    "k_f548632d": "显示最近访问路由",
    "k_5cb6d7c6": "在导航下面展示最近访问的页面，方便业务快速跳转",
    "k_ab70844c": "显示水印区分环境",
    "k_69f6080d": "开发环境和测试环境导航栏显示水印防止误操作",
    "k_14dbc5e": "公共查询参数",
    "k_807b4485": "公共查询参数的配置以 key=value 的形式拼接在链接的查询参数中, 并且在顶部导航栏中显示切换参数的组件",
    "k_bf012fb5": "启用业务隔离",
    "k_8f2c3513": "菜单组",
    "k_6334a7d1": "右侧快捷入口",
    "k_e1073a27": "导航栏组件",
    "k_c2e00121": "默认头像下拉菜单",
    "k_5ab431da": "自定义头像下拉菜单",
    "k_b9250eb": "权限配置",
    "k_8ed73419": "左侧菜单",
    "k_d6c15dbf": "菜单宽度",
    "k_5bb33fd0": "菜单选项配置",
    "k_2e41613a": "显示应用标题",
    "k_d60bff84": "显示菜单标题",
    "k_18e37385": "默认展开子级菜单",
    "k_49afbf7c": "手风琴模式",
    "k_d2a1abd": "开启后左侧菜单只会展开当前选中的菜单项，其他菜单项将不会展开",
    "k_6b48f43d": "显示搜索框",
    "k_70789227": "菜单配置",
    "k_b0bb41bb": "工作流",
    "k_4af63156": "高级流程",
    "k_9251baf8": "执行记录",
    "k_485b2fe0": "全局配置",
    "k_54b43f9c": "MCP 代理管理",
    "k_e63b073": "MCP 代理密钥",
    "k_62fd9f9b": "太湖应用 Token",
    "k_14a8fd6f": "生成 SKILL",
    "k_4a13fd75": "发布记录",
    "k_b6404365": "环境管理",
    "k_d170f433": "应用相关授权",
    "k_1f7cd3b0": "授权数据库",
    "k_6e1950df": "组件商店授权",
    "k_b07f0e3c": "应用密钥",
    "k_eee091b6": "应用COS",
    "k_5d02d01": "接入第三方鉴权",
    "k_590055d5": "设置第三方鉴权接口",
    "k_e4f4daaf": "后台鉴权数据源 ",
    "k_85ee44bd": "先设置第三方鉴权接口类型的数据源",
    "k_5a7180ee": "第三方权限系统链接",
    "k_7d16762a": "日志查询",
    "k_708eae6": "高级配置",
    "k_d42eb49e": "公告管理",
    "k_c6731ee3": "分支管理",
    "k_9a7886ed": "开启多分支",
    "k_28d0a7dd": "开启后默认分支为master分支，用户可以创建或者切换分支，分支之间的操作互相独立。",
    "k_2efbea3d": "分支保护",
    "k_74cb1461": "开启后用户将不允许直接在master进行修改，只能通过分支合并更新master",
    "k_c01afbef": "分支关联环境",
    "k_6c9c4aee": "开启后，分支创建时，会同时创建分支关联的环境并发布；当分支被删除时，关联环境也同时被删除",
    "k_eb7c1610": "发布设置",
    "k_d2d59602": "删除应用",
    "k_20f429c": "开启预发布环境",
    "k_6623f210": "发布正式环境之前，默认先发布到预发布环境，验证通过后才继续发布到正式环境,流程如下：",
    "k_ed7085c7": "开启发版审批",
    "k_c317bdc6": "版本需要通过审批获得发布到正式环境的资格后才能发布到正式环境，默认审批人为直接上级",
    "k_375663fa": "允许直接从开发环境发布版本到正式环境",
    "k_9fa8e09a": "开启发布或回滚推送流程",
    "k_84b9b9d8": "编辑器设置",
    "k_71780009": "启用 ESLint 检查",
    "k_b88b8737": "配置后可以在 LessCode 编辑器内获得 ESLint 检查",
    "k_cdc148dd": "ESLint 配置",
    "k_b7768b6c": "cosID{arg_0}不存在",
    "k_75d6d562": "获取cos鉴权失败: {arg_0}",
    "k_eec9fca9": "初始化cos实例失败",
    "k_a59b2e2a": "获取组织架构信息失败，{arg_0}",
    "k_85a2ac6d": "cosId 不存在",
    "k_8e4e67fa": "初始化组件的hmr",
    "k_ca1882be": "组件{arg_0}因为url参数被阻止实例化",
    "k_4b6e4236": "组件框架切换钩子编译失败",
    "k_6f50238b": "初始化组件商店请求:{arg_0}",
    "k_4dec3fe": "加载失败，请保存页面再刷新",
    "k_b48da60b": "打开组件编辑器",
    "k_50037619": "打开本组件的编辑页",
    "k_ffa5d2bf": "❌ 找不到指定版本的依赖包: {arg_0}",
    "k_20c05d43": "❌ 找不到指定版本的依赖包",
    "k_aa091d87": "❌ 请求的依赖包版本不存在",
    "k_c8ddc835": "❌ 找不到依赖 \"{arg_0}\", 请检查包名是否错误",
    "k_913cb600": "❌ 找不到指定依赖，请检查包名是否错误",
    "k_ef816546": "❌ 依赖包安装失败",
    "k_a8bff7e6": "❌ 依赖文件打包失败",
    "k_dfd0126d": "❌ 依赖更新失败",
    "k_b90195fd": "❌ 处理失败",
    "k_afa3a043": "📦 正在安装依赖包...",
    "k_6563763f": "⚡ 正在打包依赖文件...",
    "k_21464e43": "✅ 依赖加载完成",
    "k_daa8324c": "正在处理...",
    "k_431596e7": "正在安装依赖包...",
    "k_52a04cf3": "正在构建依赖...",
    "k_f33c986f": "构建失败",
    "k_dea9626a": "构建成功",
    "k_3059d24": "依赖加载完成",
    "k_2d329f7a": "[NpmLoader] Bundle 失败:",
    "k_b8ca50f6": "正在请求远程打包服务...",
    "k_2f23bb54": "打包服务请求失败: {arg_0}",
    "k_48d6a55e": "无法读取打包服务响应",
    "k_e0d38530": "[NpmLoader] 解析 SSE 数据失败:",
    "k_363a3033": "打包服务未返回完成事件",
    "k_196eb698": "正在本地打包依赖...",
    "k_53b21aa": "获取本地草稿失败: {arg_0}",
    "k_5d16a998": "获取远程草稿失败: {arg_0}",
    "k_a5a81b50": "找不到 id={arg_0} 的行为原子",
    "k_6ff01997": "id: 页面ID; path: 页面路径; query: 查询参数; params: 路由参数",
    "k_4df10511": "页面名称",
    "k_218fe524": "页面标题",
    "k_f91f1a04": "页面路径",
    "k_afa73ddc": "全局常量",
    "k_e18fb93": "部门ID",
    "k_24790f65": "部门IDs(分号;分割)",
    "k_559c8dc6": "中心IDs(分号;分割)",
    "k_2297b92e": "职位",
    "k_c9f2cb71": "登录渠道前端数据",
    "k_6c2db129": "可以在登录渠道-登录钩子中，按照业务需要，通过 ctx.frontendData.xxx = ... 注入数据",
    "k_ac776471": "切换账号",
    "k_169c9883": "显示账号切换浮窗。\n\n可以 await 并得到布尔值，表示用户是否执行了切换操作。",
    "k_26d2fcd9": "切换后是否刷新页面？默认 true",
    "k_7e0c6a8b": "当前环境类型",
    "k_58f08327": "当前用户",
    "k_31212c91": "用户ID",
    "k_c415ce1d": "中文名",
    "k_bef5e764": "部门名",
    "k_2dc51da8": "组织名(斜杠/分割)",
    "k_12d3d68": "组织IDs(分号;分割)",
    "k_58481ad5": "头像图地址",
    "k_ffa8f8db": "编辑侧身份",
    "k_a1e9870d": "是否管理员",
    "k_f16dd585": "是否登录",
    "k_e80971f6": "所属角色列表",
    "k_98888d52": "预览模式下无",
    "k_f0e7c62e": "权限项ID",
    "k_8a603ebf": "权限项关联的页面ID",
    "k_e15c4cd6": "权限项关联的角色名",
    "k_7de1ec17": "中心ID",
    "k_258fab2a": "小组ID",
    "k_b9843d8a": "注意：会离开当前页面",
    "k_53324722": "成功提示",
    "k_67160703": "警告提示",
    "k_912d2327": "错误提示",
    "k_276350": "加载提示",
    "k_62c862d": "全局 LessCode 实例",
    "k_f70c4830": "相关流程单",
    "k_dc2b439f": "流程状态节点ID",
    "k_6cc900fc": "流程状态节点名",
    "k_cb83ebb3": "实体ID",
    "k_429d6b95": "获取流程单列表",
    "k_aebfbded": "流程单类型",
    "k_4811b215": "筛选条件",
    "k_9b54903b": "获取流程单详情",
    "k_8bf6ae24": "获取流程审批记录",
    "k_5d7bf6b6": "流程配置ID",
    "k_79f63bf": "审批数据",
    "k_5f7ffe5a": "审批流程",
    "k_7b1edde4": "重新发起流程",
    "k_77728eba": "流程数据",
    "k_61dc85c1": "撤销流程",
    "k_eb6d4b42": "流程单是否进行中",
    "k_6734ea01": "流程单",
    "k_4ae8c9aa": "当前用户能否审批",
    "k_49eaa2fd": "重新指派审批人",
    "k_57f040e8": "审批人, 多个审批人使用英文逗号(,)分割",
    "k_f895903c": "主页面信息",
    "k_586efc1c": "获取当前的菜单组",
    "k_7dec6c3c": "设置当前的菜单组",
    "k_afb4aa71": "菜单组名",
    "k_f48a30c7": "设置当前选中的菜单项",
    "k_7e490a7e": "多级的菜单项名",
    "k_132bad1": "设置当前菜单收起/展开态",
    "k_4dbacdc8": "是否收起菜单",
    "k_fa23b63b": "获取当前菜单数据",
    "k_bedeeb66": "获取平台菜单数据",
    "k_916a77e7": "设置菜单数据",
    "k_7e1290ed": "菜单数据",
    "k_e797ccc3": "获取当前菜单名",
    "k_4cf0f0d9": "当前域名",
    "k_d9d8a40a": "当前路径",
    "k_c00f7bc": "路由查询参数",
    "k_6da6881a": "路由动态参数",
    "k_fae03fe7": "确认框",
    "k_91f2451d": "确认框配置项",
    "k_203b66": "确认框标题",
    "k_114ddf76": "确认框内容",
    "k_aeeca8a8": "确认按钮文本",
    "k_fc288d97": "取消按钮文本",
    "k_bc6de6f2": "确认回调函数",
    "k_8acb7f72": "取消回调函数",
    "k_26932b3d": "打开全局弹窗",
    "k_1d08bdb2": "打开页面类型为弹窗的全局弹窗",
    "k_627f6522": "需要打开的全局弹窗id(弹窗页面id)",
    "k_8f4d4ef7": "打开全局弹窗的传参",
    "k_62eba813": "全局弹窗的配置项，keepAlive是否保留实例，suffix用来区分实例的后缀名",
    "k_d09de7b1": "关闭全局弹窗",
    "k_d03427fa": "关闭页面类型为弹窗的全局弹窗",
    "k_9ff6c1c7": "需要关闭的\"全局弹窗id_后缀suffix\"(\"弹窗页面id__后缀suffix\")",
    "k_12b0797c": "关闭全局弹窗的返回值",
    "k_73d39db1": "关闭全局弹窗的配置项，destroy是否强制销毁实例",
    "k_68075d8e": "调用云函数",
    "k_d417a854": "云函数id",
    "k_2548f21": "透传的 axios 配置参数(可选)",
    "k_4f5746ba": "根据 key 获取公共参数的值",
    "k_5ffe70a4": "公共参数 key",
    "k_3aaf7073": "根据 key 获取公共参数的选项",
    "k_5a45336a": "根据 key 重新请求公共参数的选项",
    "k_8159f032": "请求完成后顶部导航左上角的公共参数组件选项也会更新",
    "k_abaf65be": "判断用户权限方法",
    "k_6e8b016d": "判断当前用户有没有自定义权限，如：w.hasPermission(\"custom-permission-id\")",
    "k_d3ee0d51": "权限ID(例如 `\"custom-permission-id\"`)",
    "k_a0b1dbea": "判断用户是否属于某个角色",
    "k_a51eb04f": "判断当前用户是否属于某个角色，如：w.isRoleMemberOf(\"role-id\")",
    "k_67e74c27": "角色ID(例如 `\"role-id\"`)",
    "k_7e667622": "跳转到应用内的指定页面, 保留当前页面",
    "k_8937bba9": "跳转到应用内的指定页面, 关闭当前页面",
    "k_ecbcd43c": "新窗口打开页面",
    "k_e60d9761": "新窗口打开指定页面",
    "k_db8bd10f": "获取解析的页面路径",
    "k_42c96189": "将页面滚动到目标位置",
    "k_882e2f7e": "滚动参数, 具体请查看前端 API 文档",
    "k_8f6c9596": "上报",
    "k_b79979ab": "上报数据",
    "k_fe3bdda2": "元素ID",
    "k_35c5ef3b": "行为事件",
    "k_d7c5ccb1": "确认的回调函数",
    "k_c5bb25fa": "取消的回调函数",
    "k_569ec1f3": "默认输入文本",
    "k_83e832aa": "文本类型",
    "k_9a6f497a": "持续时间",
    "k_c67dcb32": "通知类型",
    "k_571ea30a": "位置",
    "k_d6a5c795": "校验表单",
    "k_fae573e4": "表单对象",
    "k_bd571250": "校验错误信息",
    "k_28f1d79c": "调用LessCode方法",
    "k_4dfab82e": "LessCode方法名",
    "k_5180256": "是否弹出复制成功提醒",
    "k_988d37c": "数据源方法名",
    "k_cd70652e": "数据源方法入参",
    "k_f31a8864": "COS桶ID（默认一般为 \"default\"）",
    "k_7a884ba": "文件内容（字符串或Blob）",
    "k_245df27d": "上传到路径",
    "k_24ab53ce": "多环境配置（可选）",
    "k_1ce6b236": "上传头部（可选）",
    "k_3d26a736": "上传后生成的文件URL",
    "k_b84166fd": "导出数据",
    "k_9cd4de06": "导出字段",
    "k_3bf04fc0": "字段key",
    "k_9d7b7cda": "字段名",
    "k_366deca9": "Sheet名",
    "k_72e2a3ca": "导出格式",
    "k_33f341a6": "是否为原始数据",
    "k_d797a577": "是否以 Date 输出日期类型",
    "k_20e57fd2": "是否多选",
    "k_170853af": "是否支持文件夹",
    "k_bd8fd6b6": "链接地址",
    "k_7813c8d2": "是否新窗口打开",
    "k_c489e648": "垂直滚动距离(px)",
    "k_53e5978f": "组件ID",
    "k_e3c840a4": "组件偏移距离(px)",
    "k_72789283": "草稿命名空间",
    "k_9419baaa": "是否显示确认弹窗",
    "k_eca0065d": "取消后是否保留草稿",
    "k_b2408937": "收件人邮箱",
    "k_574c45bf": "抄送人邮箱",
    "k_8b3d6bc9": "密送人邮箱",
    "k_25273424": "邮件标题",
    "k_4cdb7f0f": "机器人ID",
    "k_7864dd63": "是否弹出成功提醒",
    "k_9dadd48": "接收人，多个接收人使用英文逗号(,)分割",
    "k_64574092": "通知描述",
    "k_c58ad71c": "通知链接",
    "k_5d3edd0d": "通知按钮文本",
    "k_81ce6af6": "发送GPT消息",
    "k_d8da8e3b": "系统预设Prompt",
    "k_b771908f": "消息内容",
    "k_edbfb7bf": "返回消息形式",
    "k_f149481e": "JSON字符串",
    "k_e3d80c02": "调用方法",
    "k_de254a4c": "语言模型",
    "k_73fd7845": "当前主页面的页面片实例",
    "k_80c0aaf2": "查询参数工具",
    "k_8e6b702a": "转换为过滤数组",
    "k_8d7678d2": "过滤条件",
    "k_4efef7cc": "选项",
    "k_3c77f50b": "转换为过滤表达式",
    "k_fdf548a5": "转换为嵌套过滤表达式",
    "k_92b24ea1": "全局自定义事件",
    "k_c62f4b2e": "平台预设事件",
    "k_bb2b4cb9": "全局前置守卫",
    "k_7a79173a": "全局后置守卫",
    "k_e3897292": "页面销毁前",
    "k_785f320d": "页面销毁",
    "k_256b44be": "页面数据源就绪",
    "k_55a299cb": "页面标题修改",
    "k_c0cd96a2": "监听事件",
    "k_e7a9a544": "事件名",
    "k_16036785": "事件处理函数",
    "k_105baf88": "监听事件(仅触发一次)",
    "k_15e5c942": "取消监听事件",
    "k_1ab8c1a5": "触发事件",
    "k_f9be4ad1": "获取角色列表",
    "k_7f348e0d": "获取角色-用户列表",
    "k_3d85e6a6": "选填，根据业务ID过滤",
    "k_cd0555c3": "选填，根据角色ID过滤",
    "k_279c45f4": "选填，用户id或类型type限定",
    "k_db87fcc6": "获取角色-权限列表",
    "k_3202894a": "获取角色相关权限及用户",
    "k_f0734e26": "获取自定义权限列表",
    "k_6e169561": "获取内置权限列表",
    "k_3530f0a0": "获取接口-权限列表",
    "k_90a32c54": "角色信息",
    "k_a55a7ae0": "角色英文名",
    "k_e8d8436e": "角色中文名",
    "k_223d6da": "类型，一般为空字符串即可，若是业务类型角色，则是 biz",
    "k_96472c02": "更新角色",
    "k_51139969": "只有 cname 可以更新",
    "k_d3f94caf": "权限信息",
    "k_6bbee035": "权限英文名",
    "k_30e50eed": "权限中文名",
    "k_3fb6a1a4": "类型为 page 时，可关联页面id, 逗号分隔",
    "k_e170e4e": "更新权限",
    "k_d1582cd3": "只有 cname 和 relatedPages 可以更新",
    "k_8301c6b1": "新增角色成员",
    "k_51fe1907": "角色成员信息",
    "k_9a883776": "用户英文名",
    "k_9cfb53e1": "用户类型",
    "k_926914a6": "业务id, 业务隔离，若角色是业务类型，必填",
    "k_3a9728ab": "过期时间截，ms",
    "k_13edd81f": "删除角色成员",
    "k_4ff0f22b": "角色成员记录id",
    "k_9409dc33": "新增角色权限",
    "k_85068e89": "角色权限信息",
    "k_e3adca26": "页面id，页面相关权限必填",
    "k_c964b725": "删除角色权限",
    "k_5644e476": "角色权限记录id",
    "k_f5b083d5": "批量删除角色权限",
    "k_15a3b5a3": "角色权限记录id列表",
    "k_f664145f": "新增接口权限绑定",
    "k_8de7d690": "接口权限绑定信息",
    "k_53effe81": "删除接口权限绑定",
    "k_c084da63": "接口权限绑定记录id",
    "k_d532a596": "获取公告列表",
    "k_5aa163b5": "刷新公告",
    "k_b0885b08": "水印",
    "k_dd0849e": "显示水印",
    "k_f6b95efe": "是否小程序",
    "k_c4486ea2": "是否窄屏",
    "k_3bf07f73": "屏幕尺寸信息",
    "k_5a8c0621": "AI云函数",
    "k_e55cc46e": "调用在AI编辑器里开发的后台服务接口，返回值为 axios 的响应对象（{ status, headers, data }）",
    "k_d710cc37": "请求路径",
    "k_2deca002": "请求配置",
    "k_a52a4eb9": "请求体",
    "k_102d9733": "获取行为事件",
    "k_f5153f68": "Renderer 实例",
    "k_3f5a3000": "根据 ID 获取指定组件实例（返回值为 Vue 实例）",
    "k_9f7a55ce": "组件 ID",
    "k_18ef36e8": "获取指定组件所属的页面片实例",
    "k_9c25ea2": "组件实例",
    "k_30d87fe6": "等待页面片渲染完成",
    "k_bf14b9ec": "该方法能确保后续逻辑的页面片渲染完成",
    "k_aea7f265": "等待所有数据源就绪",
    "k_e66628b3": "该方法能确保后续逻辑的数据源变量和方法的调用",
    "k_4cf8f45c": "发起 HTTP 网络请求",
    "k_e8548831": "返回值为 json.parse 后的对象, 其他与 fetch API 一致",
    "k_15de3a8f": "请求资源地址",
    "k_8f03d179": "引入前端公共模块",
    "k_bdeab364": "模块路径",
    "k_91575c1f": "请求数据源接口",
    "k_aca16052": "数据源id",
    "k_8fdb1f9e": "数据源的接口id",
    "k_4aa05650": "数据源的请求参数(可选)",
    "k_32ec29ed": "url参数",
    "k_888dd51b": "post参数",
    "k_5f79b68f": "url路径参数，前端数据源特有",
    "k_3c08d9be": "当前页面片实例",
    "k_da7bb8c1": "当前页面信息",
    "k_d92652c9": "打开当前页面的指定弹窗",
    "k_f0721f42": "需要打开的弹窗id",
    "k_2adf79b1": "打开弹窗的传参(可选)",
    "k_94fd1ac5": "关闭当前页面的指定弹窗",
    "k_a7550b3a": "需要关闭的弹窗id（可选, 当参数为空时表示关闭当前调用的弹窗）",
    "k_ec14de23": "关闭弹窗的返回值(可选)",
    "k_f0b03782": "前端API",
    "k_a25ae439": "全局上下文",
    "k_8d2b8169": "这个部署版不支持切换账号，请联系平台运维人员",
    "k_f62445c2": "切换账号的功能仅限产物端（自定义域名）下可用",
    "k_a8a0bff1": "全局弹窗{arg_0}不存在",
    "k_e0a26c8": "filter嵌套格式中，and和or 必须是数组",
    "k_d491d6bb": "filter嵌套格式中，对象上的and和or只能有一个",
    "k_45f7c739": "获取流程",
    "k_21767e56": "流程id",
    "k_2615b7b0": "执行审批",
    "k_39090a8c": "审批节点id",
    "k_c0f02b6d": "同意/拒绝",
    "k_dd04887b": "表单数据",
    "k_4aacd7d": "撤单（取消审批）",
    "k_88a26373": "附言",
    "k_238054ac": "启动流程",
    "k_ca7cb56f": "获取流程配置",
    "k_5275db4c": "获取审批节点信息",
    "k_f83449ef": "获取日志节点信息",
    "k_bf1ff4b5": "获取所有流程单",
    "k_434040f9": "流程标题，空字符串为不过滤",
    "k_f4117f5e": "发起人，空字符串为不过滤",
    "k_3b2b7508": "根据类型搜索流程单",
    "k_e0d36f63": "例如：我发起的、我参与的、与我相关、待审批",
    "k_9c641f62": "我发起的",
    "k_1eee3da2": "我参与的",
    "k_79cc91b7": "与我相关",
    "k_ba735eb9": "待审批",
    "k_af37c0bd": "组织架构",
    "k_bdd1c828": "搜索用户",
    "k_91d0087a": "过滤",
    "k_c2a35dfb": "获取用户",
    "k_de7a4c8b": "用户id",
    "k_ac70ca3d": "[wuji-lang]不存在的语言key:{arg_0}, 可选的语言{arg_1}",
    "k_13a1ae98": "与 {arg_0} 于 {arg_1} 的修改合并存在冲突, 请手动解决冲突后提交合并",
    "k_f3717392": "导航和菜单",
    "k_218cab56": "Head 脚本",
    "k_b33f454c": "Body 脚本",
    "k_3c5a529": "项目模块({arg_0})",
    "k_99237951": "{arg_0} 布局",
    "k_a119f7fa": "缺少三路合并的必要参数",
    "k_6f1ecf52": "<<<<<<< {arg_0}",
    "k_9c1e9ff5": "当前变更",
    "k_90fc9fac": ">>>>>>> {arg_0}",
    "k_5e9b558c": "最新变更",
    "k_4bd7fc71": "已自动合并本地落后的远程修改",
    "k_54c5aee8": "当前版本和最新版本有冲突，请解决冲突后进行保存",
    "k_480aa94e": "当前版本",
    "k_3504595": "最新版本",
    "k_8070d3f3": "组件名",
    "k_a6a9cbde": "泄漏次数",
    "k_457fcad5": "执行路径",
    "k_4c4ddb6d": "[routeFactory] 无法找到对应的materialId：{arg_0}",
    "k_e8048190": "{arg_0}服务: {arg_1}",
    "k_e08533af": "有部分字段保存失败",
    "k_d0df0a1d": "合并失败，保存取消",
    "k_1914e4": "loading函数已经存在",
    "k_5d5d5d09": "[FormObject]不允许获取未加载的 formProp, path={arg_0}",
    "k_d527de9e": "[FormObject]不允许重复key加载, key={arg_0}",
    "k_c7091857": "不允许重复加载, key={arg_0}, bizId={arg_1}, path={arg_2}",
    "k_91196246": "基础数据",
    "k_96bcb21f": "未找到字段prop配置，key={arg_0}",
    "k_90b8b9b9": "修改合并存在冲突, 请手动解决冲突后提交合并",
    "k_92d33cba": "非法path,key={arg_0}",
    "k_922ee988": "MaterialContainer: config 不能为空",
    "k_7a7df20b": "MaterialContainer: id {arg_0} 已经被占用，请更换其他id",
    "k_111e52a3": "targetAppId 参数有误",
    "k_62977224": "正在检查与 master 的差异",
    "k_4b1e7d17": "确认当前分支是否有待合入的提交，随后会打开合并面板",
    "k_2055a827": "master 不能合入自己",
    "k_a23a9e5": "合并目标是 master。请从功能分支打开此页。",
    "k_885858f9": "没有待合入的提交",
    "k_b0630294": "当前分支与 master 没有可合并的差异。",
    "k_ce5fb2aa": "已合入 master",
    "k_1b44f88": "分支变更已经写入 master。",
    "k_7007826e": "未开启多分支",
    "k_164f5196": "当前应用没有开启多分支，无法合并。",
    "k_f7daf3b6": "缺少合并参数",
    "k_274d2de7": "请带上 projectid 和 branch 后再进入此页。",
    "k_13383026": "合并未能完成",
    "k_e09d7ed0": "合并失败，请稍后重试",
    "k_503d4924": "合并未提交，请重新进入此页继续合并",
    "k_7c072e6d": "合并分支",
    "k_8bd2f536": "未知分支",
    "k_45a10094": "进入工作台",
    "k_d845ee90": "已废弃且不生效",
    "k_46dcf93f": "新建数据库",
    "k_e3b18149": "创建数据库",
    "k_ebdfa66d": "挂载外部数据库",
    "k_95a00aa6": "可授权您在",
    "k_2cccbe11": "中登记的数据库",
    "k_38ec776f": "目标数据库",
    "k_3f77270b": "请选择数据库",
    "k_ea08e9b": "请选择数据库，输入 appId 或 name 进行搜索",
    "k_b25b2229": "您没有该数据库的管理员权限，请让管理员进行授权",
    "k_b171cc99": "请输入数据库 ID",
    "k_7922dffb": "数据库 ID 只能包含字母、数字和下划线",
    "k_97ce6a09": "请输入数据库名称",
    "k_99100717": "请输入数据库管理员",
    "k_b4eed97d": "数据库 ID",
    "k_158cb448": "请输入数据库 ID，只能使用字母、数字和下划线",
    "k_96fdcdad": "数据库名称",
    "k_ed37c1de": "请输入数据库名称，建议输入一个可读的中文名",
    "k_94225d46": "数据库描述",
    "k_ccf8301f": "管理员",
    "k_367bfd12": "请输入需要访问的数据库名称",
    "k_bedbbe5a": "请输入数据库用户名",
    "k_c36d1d98": "请输入数据库的密码",
    "k_c73bb71c": "请输入数据库的 ip 地址",
    "k_8d1f1aff": "请输入数据库的端口号",
    "k_9e60d1a4": "请输入数据库的域名或北极星地址",
    "k_4de55a69": "数据库类型",
    "k_fd52d17c": "项目 ID",
    "k_835f8b45": "请输入项目 ID，用于平台内的唯一标识，只能使用字母、数字和下划线",
    "k_341510b3": "请输入项目名称，建议输入一个可读的中文名",
    "k_4f1ef1b": "项目描述",
    "k_d53450f4": "请输入项目描述，建议描述数据内容、数据来源和用途等",
    "k_27ee35e1": "对应\"character_set_client\",\"character_set_connection\", \"character_set_results\"设置",
    "k_10115b2d": "默认值为 utf8mb4",
    "k_a227d0d4": "字符排序方式",
    "k_62a0d37f": "默认值为 `UTF8MB4_GENERAL_CI`，注意字符集的字母都要大写。",
    "k_a1fda65b": "大数字",
    "k_54f68f51": "如挂载表中涉及 `BIGINT` 类型，需要开启该属性",
    "k_be516831": "数据库",
    "k_bf5c5e65": "请输入目标数据库的名称",
    "k_de99cde5": "用户名",
    "k_cd3796ba": "数据库用户名",
    "k_5602e656": "数据库密码",
    "k_193a3435": "数据库 IP",
    "k_a0ccb0fa": "数据库端口号",
    "k_ee0e963e": "数据库的 Host",
    "k_a5f6037b": "连接方式",
    "k_416a7866": "域名或北极星",
    "k_158e50c3": "数据库需授权必要的数据操作权限, 详情请见文档",
    "k_745b7179": "挂载自有数据库 »",
    "k_4dc9f724": "测试连接",
    "k_17d96e39": "测试成功",
    "k_81ac8f7b": "测试失败: {arg_0}",
    "k_18885fa5": "最近访问",
    "k_a3d869a9": "表单校验失败",
    "k_f968ede0": "授权失败",
    "k_847607cc": "用户主动关闭弹窗",
    "k_5e0498b": "请求失败",
    "k_e5b4fef4": "未知错误，请关闭后重试",
    "k_bc6055e1": "[ProjectNameHandler] Element with data-i18n=\"project-name\" not found"
};
